<template>
  <b-row align-h="center" v-if="dataLoading" class="mt-2">
    <b-spinner
      style="width: 4rem; height: 4rem"
      type="grow"
      variant="primary"
      label="Spinning"
    ></b-spinner>
  </b-row>
  <div v-else>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Projects</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideSideBar()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="d-flex align-items-center">
          <b-col md="10">
            <b-form-group
              label="Project Name"
              invalid-feedback="Project name is required."
            >
              <b-form-input
                ref="dep_name"
                v-model="depObj.name"
                placeholder="Enter project name"
                @focusout="CheckName()"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-button
              variant="success"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="addDep()"
              :disabled="saving"
            >
              <b-spinner v-if="saving" small type="grow" />
              <feather-icon v-else :icon="accIcon" />
            </b-button>
          </b-col>
        </b-row>
        <b-table
          class="mt-1"
          show-empty
          :items="depList"
          :fields="depFields"
          responsive
          hover
          small
        >
          <template #head(actions)="data">
            <div class="text-right">
              <span>{{ data.label }}</span>
            </div>
          </template>

          <template #cell(actions)="data">
            <div class="d-flex">
              <b-button
                variant="primary"
                class="btn-icon mr-50"
                @click="Edit(data.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                variant="outline-danger"
                class="btn-icon"
                @click="Delete(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
            </div>
          </template>
        </b-table>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebarVendor"
      bg-variant="white"
      v-model="visibilityVendor"
      sidebar-class="sidebar-lg"
      right
      width="500"
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Vendors</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideSideBarVendor()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="d-flex align-items-center">
          <b-col md="10">
            <b-form-group
              label="Vendor Name"
              invalid-feedback="Vendor name is required."
            >
              <b-form-input
                ref="vendor_name"
                class="mb-50"
                v-model="vendorObj.name"
                placeholder="Enter vendor name"
                @focusout="CheckVendorName()"
              >
              </b-form-input>
              <b-form-input
                ref="vendor_mobile"
                v-model="vendorObj.mobile_number"
                placeholder="Enter mobile no."
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-button
              variant="success"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="addVendor()"
              :disabled="saving"
            >
              <b-spinner v-if="saving" small type="grow" />
              <feather-icon v-else :icon="accIcon" />
            </b-button>
          </b-col>
        </b-row>
        <b-table
          class="mt-1"
          show-empty
          :items="vendorList"
          :fields="vendorFields"
          responsive
          hover
          small
        >
          <template #head(actions)="data">
            <div class="text-right">
              <span>{{ data.label }}</span>
            </div>
          </template>

          <template #cell(actions)="data">
            <div class="d-flex">
              <b-button
                variant="primary"
                class="btn-icon mr-50"
                @click="EditVendor(data.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                variant="outline-danger"
                class="btn-icon"
                @click="DeleteVendor(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
            </div>
          </template>
        </b-table>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility2"
      sidebar-class="sidebar-lg"
      right
      width="600"
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Voucher Settings</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility2 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row>
          <b-col md="12" v-for="(item, ind) in vtSaveData" :key="ind">
            <b-form-group
              :label="item.voucherType"
              invalid-feedback="Account is required."
            >
              <v-select
                :ref="'account' + ind"
                :filterBy="dropFilter"
                v-model="item.accountID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="accList"
                :reduce="(opt) => opt.id"
                label="title"
                :clearable="true"
                placeholder="Select account"
                class="account-select"
              >
                <template #option="option">
                  <div 
                    class="account-option"
                    v-b-tooltip.hover.top
                    :title="`${option.title} (${option.code})`"
                  >
                    <div class="account-name">{{ option.title }}</div>
                    <div class="account-code">{{ option.code }}</div>
                  </div>
                </template>
                <template #selected-option="option">
                  <div class="account-selected">
                    <span class="account-name-text">{{ option.title }}</span>
                    <span class="account-code-text" v-if="option.code">{{ option.code }}</span>
                  </div>
                </template>
              </v-select>
              <!-- @input="testing(item)" -->
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-button
              variant="success"
              @click="saveVtSettings()"
              :disabled="saving"
              block
            >
              <b-spinner v-if="saving" small type="grow" />
              <span v-else>{{$t('Save')}}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-modal id="modal-grn" title="Goods Receiving Note" centered size="lg">
      <b-table
        :items="supplierGrns"
        :fields="grnFields"
        responsive
        show-empty
        selectable
        select-mode="multi"
        @row-selected="selectGrn"
      >
        <template #cell(id)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(quotationID)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(date)="data">
          <b-badge variant="light-primary">
            {{
              new Date(data.value).toLocaleDateString("en-UK", {
                year: "numeric",
                day: "numeric",
                month: "short",
              })
            }}
          </b-badge>
        </template>
        <template #cell(total)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(deliveryCharges)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(note)="data">
          {{ data.value }}
        </template>
      </b-table>

      <template #modal-footer>
        <b-button
          variant="success"
          class="btn-icon"
          :disabled="selectedList.length == 0"
          @click="confirmGrn()"
        >
          <span class="align-middle">Confirm</span>
        </b-button>
      </template>
    </b-modal>

    <!-- Combined Header and Form Card -->
    <b-card class="voucher-form-card">
      <!-- Header Section -->
      <div class="voucher-header-section mb-4">
        <div class="header-content">
          <div class="d-flex align-items-center gap-2 mb-2">
            <b-button
              variant="outline-secondary"
              class="btn-icon rounded-circle back-btn"
              @click="goBack"
            >
              <feather-icon icon="ArrowLeftIcon" size="16" class="back-arrow-icon" />
            </b-button>
            <h3 class="voucher-title mb-0">{{ pageTitle }}</h3>
          </div>
          <p class="voucher-description">
            <template v-if="currentVoucherMode === 'bank'">
              Record a new bank payment or receipt transaction.
            </template>
            <template v-else-if="currentVoucherMode === 'credit'">
              Record a new cash payment or receipt transaction.
            </template>
            <template v-else-if="currentVoucherMode === 'transfer'">
              Record a new transfer transaction between accounts.
            </template>
            <template v-else>
              Record a new journal entry transaction.
            </template>
          </p>
        </div>
        <template v-if="saveObj.id == 0 && accObj && accObj.valueBool">
          <div class="header-actions">
            <b-input-group class="grn-search-input">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input
                v-model.trim="searchID"
                placeholder="Enter GRN ID here"
                :disabled="poLoading"
                @keyup.enter="checkGrnID()"
              />
            </b-input-group>
            <v-select
              v-model="supplierObj"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="supplierList"
              label="name"
              placeholder="Select vendor"
              clearable
              :disabled="poLoading"
              class="vendor-select"
              @input="getGrn()"
            />
          </div>
        </template>
      </div>
      <b-row>
        <!-- Voucher Type - Only for Bank and Credit vouchers -->
        <b-col md="2" v-if="showVoucherTypeDropdown">
          <b-form-group invalid-feedback="Voucher Type is required." ref="vt" class="form-group-modern">
            <label class="form-label-modern">Voucher Type</label>
            <v-select
              v-model="saveObj.voucherType"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="filteredTypeOptions"
              :reduce="(opt) => opt.text"
              label="text"
              :clearable="false"
              ref="vt"
              placeholder="Select type"
              class="v-select-simple"
              append-to-body
              @input="setVT()"
            />
          </b-form-group>
        </b-col>

        <!-- Voucher No - add (preview) and edit (read-only) -->
        <b-col md="2" v-if="saveObj.id > 0 || $route.params.id == 0">
          <b-form-group class="form-group-modern">
            <label class="form-label-modern">Voucher No</label>
            <b-form-input
              :value="displayVoucherNo"
              disabled
              class="form-control-modern voucher-no-readonly"
              placeholder="-"
            />
          </b-form-group>
        </b-col>

        <!-- Date Field -->
        <b-col :md="getDateColumnSize()">
          <b-form-group
            invalid-feedback="Date is required"
            ref="date"
            class="form-group-modern"
          >
            <label class="form-label-modern">Date</label>
            <div class="date-input-wrapper-enhanced">
              <flat-pickr
                :config="config"
                ref="date"
                v-model="saveObj.date"
                class="form-control-modern date-input-enhanced"
                placeholder="mm/dd/yyyy"
                :disabled="rights.disableDate"
              />
              <feather-icon icon="CalendarIcon" size="18" class="date-input-icon-enhanced" />
            </div>
          </b-form-group>
        </b-col>

        <!-- Bank Account Field - For Bank and Credit vouchers only -->
        <b-col :md="getBankAccountColumnSize()" v-if="currentVoucherMode === 'bank' || currentVoucherMode === 'credit'">
          <b-form-group
            :invalid-feedback="currentVoucherMode === 'credit' ? 'Cash Account is required.' : 'Bank Account is required.'"
            ref="bankAccount"
            class="form-group-modern"
          >
            <label class="form-label-modern">{{ currentVoucherMode === 'credit' ? 'Cash Account' : 'Bank Account' }}</label>
            <v-select
              :filterBy="dropFilter"
              v-model="saveObj.bankAccountID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="bankAccountList"
              :reduce="(opt) => opt.id"
              label="title"
              :clearable="false"
              ref="bankAccount"
              placeholder="Select account"
              class="v-select-simple account-select"
              append-to-body
              @input="fetchNextChequeNo()"
            >
              <template #option="option">
                <div class="account-option">
                  <div class="account-name">{{ option.title || '' }}</div>
                  <div class="account-code">{{ option.code || '' }}</div>
                </div>
              </template>
              <template #selected-option="option">
                <div class="account-selected">
                  <span class="account-name-text">{{ option ? option.title : '' }}</span>
                  <span class="account-code-text" v-if="option && option.code">{{ option.code }}</span>
                </div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <!-- Reference/Cheque No Field -->
        <b-col :md="getChequeColumnSize()">
          <b-form-group
            :invalid-feedback="currentVoucherMode === 'credit' ? 'Reference required.' : 'Reference/Cheque No required.'"
            ref="chTitle"
            class="form-group-modern"
          >
            <label class="form-label-modern">{{ currentVoucherMode === 'credit' ? 'Reference' : 'Reference / Cheque No.' }}</label>
            <b-form-input
              ref="chTitle"
              :placeholder="currentVoucherMode === 'credit' ? 'e.g. REF-001' : 'e.g. CHQ-445912'"
              v-model="saveObj.chequeTitle"
              class="form-control-modern"
            />
          </b-form-group>
        </b-col>

        <!-- Payee Field - For Journal/Transfer -->
        <b-col :md="getPayeeColumnSize()" v-if="currentVoucherMode === 'journal' || currentVoucherMode === 'transfer'">
          <b-form-group
            ref="payee"
            class="form-group-modern"
          >
            <label class="form-label-modern">Payee</label>
            <b-form-input
              ref="payee"
              placeholder="Enter payee name"
              v-model="saveObj.payee"
              class="form-control-modern"
            />
          </b-form-group>
        </b-col>

        <!-- Master Narration Field - In same line for Journal/Transfer -->
        <b-col :md="getNarrationColumnSize()" v-if="currentVoucherMode === 'journal' || currentVoucherMode === 'transfer'">
          <b-form-group
            invalid-feedback="Master Narration required."
            ref="masterNarration"
            class="form-group-modern"
          >
            <label class="form-label-modern">Master Narration</label>
            <b-form-input
              ref="masterNarration"
              placeholder="Being payment made for..."
              v-model="saveObj.description"
              class="form-control-modern"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Project and Vendor Fields Row -->
      <b-row v-if="multiDep && multiDep.valueBool">
        <!-- Project Field -->
        <b-col md="3">
          <b-form-group invalid-feedback="Project is required." ref="dep" class="form-group-modern">
            <label class="form-label-modern">
              Project
              <feather-icon
                class="cursor-pointer settings-icon ml-1"
                icon="EditIcon"
                size="16"
                v-b-tooltip.hover.top
                title="Manage Projects"
                @click="openDep()"
              />
            </label>
            <v-select
              v-model="saveObj.departmentID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="depList"
              :reduce="(opt) => opt.id"
              label="name"
              :clearable="false"
              ref="dep"
              placeholder="Select project"
              class="v-select-modern"
            />
          </b-form-group>
        </b-col>

        <!-- Vendor Field -->
        <b-col md="3">
          <b-form-group invalid-feedback="Vendor is required." ref="vendor" class="form-group-modern">
            <label class="form-label-modern">
              Vendor
              <feather-icon
                class="cursor-pointer settings-icon ml-1"
                icon="EditIcon"
                size="16"
                v-b-tooltip.hover.top
                title="Manage Vendors"
                @click="openVendor()"
              />
            </label>
            <v-select
              v-model="saveObj.vendorID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="[{ id: 0, name: 'None' }, ...vendorList]"
              :reduce="(opt) => opt.id"
              label="name"
              :clearable="false"
              ref="vendor"
              placeholder="Select Vendor"
              class="v-select-modern"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Payee and Master Narration Fields - Separate row for Bank/Credit vouchers -->
      <b-row v-if="currentVoucherMode === 'bank' || currentVoucherMode === 'credit' || currentVoucherMode === ''">
        <!-- Payee Field -->
        <b-col md="12">
          <b-form-group
            ref="payee"
            class="form-group-modern"
          >
            <label class="form-label-modern">Payee</label>
            <b-form-input
              ref="payee"
              placeholder="Enter payee name"
              v-model="saveObj.payee"
              class="form-control-modern"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            invalid-feedback="Master Narration required."
            ref="masterNarration"
            class="form-group-modern"
          >
            <label class="form-label-modern">Master Narration</label>
            <b-form-input
              ref="masterNarration"
              placeholder="Being payment made for..."
              v-model="saveObj.description"
              class="form-control-modern"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <!-- Entries Table Card -->
    <b-card class="entries-table-card mb-4">
      <div class="entries-table-wrapper">
        <table class="entries-table">
          <thead>
            <tr>
              <th class="sno-col">#</th>
              <th class="account-col">PARTICULARS (ACCOUNT)</th>
              <th class="description-col">DESCRIPTION</th>
              <th class="debit-col">DEBIT (DR)</th>
              <th class="credit-col">CREDIT (CR)</th>
              <th class="action-col">ACTION</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, ind) in myObj" :key="ind" class="entry-row">
              <td class="sno-col">
                <div class="sno-badge">{{ String(ind + 1).padStart(2, '0') }}</div>
              </td>
              <td class="account-col">
                <v-select
                  :filterBy="dropFilter"
                  v-model="item.accountID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="filteredAccList"
                  :reduce="(opt) => opt.id"
                  label="title"
                  :clearable="false"
                  :disabled="byGrn || isTableAccountSelectDisabled(item, ind)"
                  ref="acc"
                  placeholder="Select Account"
                  class="account-select"
                  append-to-body
                  @input="onTableAccountChange(item, ind)"
                >
                  <template #option="option">
                    <div class="account-option">
                      <div class="account-name">{{ option.title }}</div>
                      <div class="account-code">{{ option.code }}</div>
                    </div>
                  </template>
                  <template #selected-option>
                    <div class="account-selected">
                      <span class="account-name-text">{{ getAccountName(item.accountID) }}</span>
                      <span class="account-code-text" v-if="getAccountCode(item.accountID)">
                        {{ getAccountCode(item.accountID) }}
                      </span>
                    </div>
                  </template>
                </v-select>
              </td>
              <td class="description-col">
                <b-form-input
                  type="text"
                  placeholder="Line description"
                  ref="note"
                  v-model="item.description"
                  class="description-input"
                      :disabled="byGrn"
                />
              </td>
              <td class="debit-col">
                <b-form-input
                  :id="'debit' + ind"
                  type="number"
                  step="any"
                  min="0"
                  ref="debit"
                  placeholder="0.00"
                  v-model="item.debit"
                  :disabled="isRowDebitDisabled(item, ind)"
                  class="amount-input debit-input"
                  @input="handleDebitCreditChange(item, ind)"
                />
              </td>
              <td class="credit-col">
                <b-form-input
                  type="number"
                  step="any"
                  min="0"
                  placeholder="0.00"
                  ref="credit"
                  v-model="item.credit"
                  :disabled="isRowCreditDisabled(item, ind)"
                  class="amount-input credit-input"
                  @input="handleDebitCreditChange(item, ind)"
                />
              </td>
              <td class="action-col">
                <div class="table-action-buttons">
                  <b-button
                    v-if="isLastEditableEntryRow(ind)"
                    @click="AddValue(item, ind + 1)"
                    variant="primary"
                    class="table-action-btn table-action-btn-add"
                    size="sm"
                  >
                    <feather-icon icon="PlusIcon" size="16" />
                  </b-button>
                  <b-button
                    v-if="canRemoveEntry(item, ind)"
                    @click="removeValue(item, ind)"
                    variant="outline-danger"
                    class="table-action-btn table-action-btn-remove"
                    size="sm"
                  >
                    <feather-icon icon="XIcon" size="16" />
                  </b-button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <!-- Summary Section -->
      <div class="entries-summary">
        <div class="summary-right">
          <div class="summary-item">
            <span class="summary-label">TOTAL DEBIT</span>
            <span class="summary-value debit-total">Rs. {{ formatNumber(totalDebit) }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">TOTAL CREDIT</span>
            <span class="summary-value credit-total">Rs. {{ formatNumber(totalCredit) }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">DIFFERENCE</span>
            <span 
              class="summary-value difference-value"
              :class="{ 'difference-unbalanced': !ledgerAmountsBalanced }"
            >
              Rs. {{ formatNumber(Math.abs(totalDebit - totalCredit)) }} 
              <span v-if="!ledgerAmountsBalanced">
                {{ totalDebit > totalCredit ? 'Dr' : 'Cr' }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </b-card>

    <!-- Attachments Section - Compact Header -->
    <div class="attachments-header-compact mb-3">
      <div class="attachments-title-wrapper">
        <h3 class="attachments-title-compact mb-0">Attachments</h3>
        <button
          class="attachment-add-btn-inline"
          @click="showAttachmentsModal = true"
          v-b-tooltip.hover.top
          title="Manage Attachments"
        >
          <feather-icon icon="PlusIcon" size="20" />
          <span v-if="attachList.length > 0" class="attachment-count-badge-inline">{{ attachList.length }}</span>
        </button>
      </div>
    </div>

    <!-- Attachments Modal -->
    <b-modal
      id="modal-attachments"
      v-model="showAttachmentsModal"
      title="Attachments"
      size="lg"
      centered
      hide-footer
      @hidden="showAttachmentsModal = false"
    >
      <div class="attachments-container-modal">
        <!-- Add Attachment Button -->
        <div
          class="attachment-item attachment-add"
          @click="!mydocloading && $refs.psamplefile.click()"
        >
          <div class="attachment-circle">
            <b-spinner
              v-if="mydocloading"
              small
              label="Loading..."
              variant="primary"
            />
            <feather-icon v-else icon="PlusIcon" size="28" class="attachment-icon" />
          </div>
          <span class="attachment-label">Add</span>
        </div>

        <!-- Attachment Items -->
        <div
          class="attachment-item"
          v-for="(file, index) in attachList"
          :key="index"
          :style="{ animationDelay: `${index * 0.1}s` }"
        >
          <div class="attachment-circle-wrapper">
            <div class="attachment-circle attachment-file" @click="openFile(getAttachUrl(file))">
              <!-- Loading state for images -->
              <div v-if="isPreviewableAttach(file) && imageLoading[getAttachUrl(file)]" class="attachment-loading">
                <b-spinner small variant="primary" />
              </div>
              <!-- Show image if it's an image file -->
              <img
                v-if="isPreviewableAttach(file)"
                :src="getAttachPreviewUrl(file)"
                :alt="getFileName(file, index)"
                referrerpolicy="no-referrer"
                class="attachment-image"
                @load="onAttachImageLoad(file)"
                @error="handleAttachPreviewError($event, file)"
                @loadstart="onAttachImageLoadStart(file)"
                v-show="!imageLoading[getAttachUrl(file)]"
              />
              <!-- Show icon for non-image files -->
              <feather-icon
                v-else
                icon="FileTextIcon"
                size="24"
                class="attachment-file-icon"
              />
            </div>
            <div class="attachment-delete" @click.stop="deleteDocument(index)">
              <feather-icon icon="XIcon" size="14" />
            </div>
          </div>
          <span class="attachment-label">{{ getFileName(file, index) }}</span>
        </div>

        <input
          type="file"
          id="psamplefile"
          hidden
          ref="psamplefile"
          multiple
          @change="PsampleAdd()"
          accept="image/*,application/pdf"
        />
      </div>
      
      <div class="modal-footer-actions mt-3">
        <b-button variant="secondary" @click="showAttachmentsModal = false">
          Close
        </b-button>
      </div>
    </b-modal>

    <!-- Action Buttons - Full Width Professional Layout -->
    <div class="action-buttons-row">
      <b-button
        v-ripple.400="'rgba(124, 93, 250, 0.15)'"
        @click="Add()"
        :disabled="request || poLoading"
        class="action-btn action-btn-save"
      >
        <b-spinner v-if="request" small type="grow" class="mr-2" />
        <feather-icon v-else icon="SaveIcon" size="20" class="mr-2" />
        <span>Save</span>
      </b-button>

      <b-button
        v-ripple.400="'rgba(124, 93, 250, 0.15)'"
        @click="Add('print')"
        :disabled="request || poLoading"
        class="action-btn action-btn-print"
      >
        <b-spinner v-if="request" small type="grow" class="mr-2" />
        <feather-icon v-else icon="PrinterIcon" size="20" class="mr-2" />
        <span>Save & Print</span>
      </b-button>

      <b-button
        v-if="$route.params.id == 0"
        v-ripple.400="'rgba(255, 193, 7, 0.15)'"
        @click="Add(true)"
        :disabled="request || poLoading"
        class="action-btn action-btn-approval"
      >
        <b-spinner v-if="request" small type="grow" class="mr-2" />
        <feather-icon v-else icon="CheckCircleIcon" size="20" class="mr-2" />
        <span>Request For Approval</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BBadge,
  BTable,
  BFormInput,
  BButton,
  BSidebar,
  BFormGroup,
  BInputGroupPrepend,
  BInputGroup,
  BForm,
  BSpinner,
  BModal,
  VBTooltip,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { mapActions, mapGetters } from "vuex";
import {
  buildUploadedAttachment,
  getDocumentDisplayName,
  getDriveImagePreviewCandidates,
  getDocPreviewUrl as resolveDocPreviewUrl,
  getDocUrl as resolveDocUrl,
  handleDrivePreviewError,
  isPreviewableDoc as checkPreviewableDoc,
  parseDocUrls,
  serializeDocUrls,
  uploadToMySkool,
} from "@/utils/gdriveUpload";
import roleCoaAccessMixin from "@/mixins/roleCoaAccessMixin";

const JOURNAL_EDIT_STORAGE_PREFIX = "myskool-journal-edit-data-";
const VOUCHER_LAST_ACCOUNT_STORAGE_PREFIX = "myskool-voucher-last-account-";

export default {
  mixins: [roleCoaAccessMixin],
  components: {
    BCard,
    BRow,
    BCol,
    BBadge,
    BTable,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BForm,
    BSpinner,
    BModal,
    flatPickr,
    vSelect,
  },
  props: {
    voucherMode: {
      type: String,
      default: "", // journal, bank, credit, transfer, or empty for default behavior
    },
    voucherType: {
      type: String,
      default: "",
    },
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  async created() {
    // Map route names to base rights
    const rightsKey = "journal-advance";
    let right = this.$store.state.rights[rightsKey];

    // If not found, try alternate keys
    if (!right) {
      right = this.$store.state.rights["journal"] || this.$store.state.rights["journal-advance"];
    }

    if (!right) {
      // Default rights if not found
      right = { view: true, add: true, edit: true, delete: true };
    }
    
    this.rights = right;

    this.$route.params.id = parseInt(this.$route.params.id);
    if (this.$route.params.id > 0 && right.edit) {
      let entryLoaded = false;

      if (this.$route.params.data && this.$route.params.data.entry) {
        this.saveObj = this.$route.params.data.entry;
        this.myObj = this.$route.params.data.details;
        entryLoaded = true;
      } else {
        const storedItem = this.readJournalEditStorage(this.$route.params.id);
        if (storedItem) {
          this.saveObj = storedItem.entry;
          this.myObj = storedItem.details || [];
          this.$route.params.data = storedItem;
          entryLoaded = true;
        }
      }

      if (!entryLoaded) {
        entryLoaded = await this.loadEntryForEdit(this.$route.params.id);
        if (entryLoaded) {
          this.$route.params.data = {
            entry: this.saveObj,
            details: this.myObj,
          };
        }
      }

      if (!entryLoaded) {
        this.$router.replace({
          name: "misc-not-authorized",
        });
        return;
      }

      await this.initializeEditEntry();
    } else if (this.$route.params.id == 0 && right.add) {
      // Set default voucher type based on mode
      const mode = this.currentVoucherMode;
      const queryVoucherType = this.$route.query?.voucherType;
      
      if (mode === "journal" || mode === "transfer") {
        this.saveObj.voucherType = "JV";
      } else if (mode === "bank") {
        this.saveObj.voucherType =
          queryVoucherType ||
          (this.allowFlexibleLedgerDrCr
            ? this.getSavedVoucherType("bank")
            : "") ||
          "BPV";
      } else if (mode === "credit") {
        this.saveObj.voucherType =
          queryVoucherType ||
          (this.allowFlexibleLedgerDrCr
            ? this.getSavedVoucherType("cash")
            : "") ||
          "CPV";
      } else if (queryVoucherType) {
        this.saveObj.voucherType = queryVoucherType;
      }
      
      this.LoadAccounts();
      this.loadDeps();
      this.loadVtSettings();
      this.LoadSettings();
      this.LoadSettingsAll();
      this.loadVendors();
      this.setCurrentDate();
      this.fetchNextVoucherNo();
    } else {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    }

    if (this.reportDomain == "myskoolelixir") {
      this.typeOptions.push({ text: "INV", value: "INV" });
    }
  },
  watch: {
    'saveObj.bankAccountID'(newVal, oldVal) {
      if (newVal !== oldVal && this.isBankOrCreditVoucher) {
        if (newVal > 0) {
          this.saveLastVoucherAccount(newVal);
        }

        this.syncFlexibleHeaderBankRow(newVal, oldVal || 0);

        if (this.allowFlexibleLedgerDrCr) {
          return;
        }

        if (newVal > 0) {
          this.$nextTick(() => {
            const vType = this.saveObj.voucherType;
            if (vType === "BPV" || vType === "BRV") {
              this.autoBalanceBankVoucher();
            } else if (vType === "CPV" || vType === "CRV") {
              this.autoBalanceCreditVoucher();
            }
          });
        }
      }
    },
    'saveObj.description'(newVal) {
      // Update bank account entry description when narration changes
      if (this.isBankOrCreditVoucher && this.saveObj.bankAccountID > 0) {
        const bankEntry = this.myObj.find(entry => entry.accountID === this.saveObj.bankAccountID);
        if (bankEntry) {
          bankEntry.description = newVal || "Bank Account";
        }
      }
    },
    'saveObj.chequeTitle'(newVal) {
      // Update bank account entry chequeNo when cheque title changes
      if (this.isBankOrCreditVoucher && this.saveObj.bankAccountID > 0) {
        const bankEntry = this.myObj.find(entry => entry.accountID === this.saveObj.bankAccountID);
        if (bankEntry) {
          bankEntry.chequeNo = newVal || "";
        }
      }
    },
    'saveObj.voucherType'(newVal) {
      if (parseInt(this.$route.params.id) === 0) {
        this.fetchNextVoucherNo();
      }

      if (
        this.allowFlexibleLedgerDrCr &&
        parseInt(this.$route.params.id) === 0 &&
        ["BPV", "BRV", "CPV", "CRV"].includes(newVal)
      ) {
        this.saveLastVoucherPreferences({ voucherType: newVal });
      }

      const isBankCreditVoucher = ["BPV", "BRV", "CPV", "CRV"].includes(newVal);
      if (this.allowFlexibleLedgerDrCr && isBankCreditVoucher) {
        return;
      }

      // Clear invalid debit/credit values when voucher type changes
      const vType = newVal;
      
      if (vType === "BPV" || vType === "CPV") {
        // Only debit allowed, clear all credit values (except bank/cash rows)
        this.myObj.forEach((item, ind) => {
          if (
            !this.isBankAccountEntry(item, ind) &&
            !this.isBankOrCashAccount(item.accountID)
          ) {
            item.credit = 0;
          }
        });
      } else if (vType === "BRV" || vType === "CRV") {
        // Only credit allowed, clear all debit values (except bank/cash rows)
        this.myObj.forEach((item, ind) => {
          if (
            !this.isBankAccountEntry(item, ind) &&
            !this.isBankOrCashAccount(item.accountID)
          ) {
            item.debit = 0;
          }
        });
      }
    },
  },
  computed: {
    totalCredit() {
      const raw = this.myObj.reduce((sum, el) => {
        const credit = parseFloat(el.credit) || 0;
        return sum + credit;
      }, 0);
      return Math.round(raw * 100) / 100;
    },
    totalDebit() {
      const raw = this.myObj.reduce((sum, el) => {
        const debit = parseFloat(el.debit) || 0;
        return sum + debit;
      }, 0);
      return Math.round(raw * 100) / 100;
    },
    ledgerAmountsBalanced() {
      return Math.abs(this.totalDebit - this.totalCredit) <= 0.005;
    },
    isAbaDomain() {
      return this.reportDomain === "myskoolaba";
    },
    allowFlexibleLedgerDrCr() {
      return ["myskoolaba", "myskool"].includes(this.reportDomain);
    },
    // Get voucher mode from prop or query params
    currentVoucherMode() {
      const fromRoute = this.voucherMode || this.$route.query?.voucherMode || "";
      if (fromRoute) return fromRoute;
      return this.inferVoucherMode(this.saveObj?.voucherType);
    },
    // Page title based on mode
    pageTitle() {
      switch (this.currentVoucherMode) {
        case "bank":
          return "Bank Voucher Entry";
        case "credit":
          return "Cash Voucher Entry";
        case "transfer":
          return "Transfer Voucher Entry";
        case "journal":
          return "Journal Entry";
        default:
          return "Journal Entry";
      }
    },
    displayVoucherNo() {
      if (!this.saveObj) return "";
      if (parseInt(this.$route.params.id) === 0 && this.saveObj.id <= 0) {
        return this.nextVoucherNo || "";
      }
      const type = this.saveObj.voucherType || "";
      const num = this.saveObj.voucherNum;
      if (type && num != null && num !== "") {
        return `${type}-${num}`;
      }
      if (num != null && num !== "") return String(num);
      return "";
    },
    // Show dropdown only for bank and credit modes
    showVoucherTypeDropdown() {
      return this.currentVoucherMode === "bank" || this.currentVoucherMode === "credit" || this.currentVoucherMode === "";
    },
    // Filtered type options based on mode
    filteredTypeOptions() {
      if (this.currentVoucherMode === "bank") {
        return this.typeOptions.filter(opt => ["BPV", "BRV"].includes(opt.text));
      } else if (this.currentVoucherMode === "credit") {
        return this.typeOptions.filter(opt => ["CPV", "CRV"].includes(opt.text));
      } else if (this.currentVoucherMode === "journal" || this.currentVoucherMode === "transfer") {
        return this.typeOptions.filter(opt => opt.text === "JV");
      }
      return this.typeOptions;
    },
    // Return filtered accounts based on voucher type for bank/cash account dropdown
    bankAccountList() {
      if (!this.accList || this.accList.length === 0) return [];
      const vType = this.saveObj.voucherType;
      const mode = this.currentVoucherMode;
      
      // Bank Voucher: Show only accounts with category "bank_account"
      if (vType === "BPV" || vType === "BRV") {
        return this.accList.filter(acc => acc.cashFlowCategory === "bank_account" && !acc.isParent);
      }
      
      // Credit Voucher: Show only accounts with category "cash_account"
      if (vType === "CPV" || vType === "CRV") {
        return this.accList.filter(acc => acc.cashFlowCategory === "cash_account" && !acc.isParent);
      }
      
      // Transfer Voucher: Show all accounts
      if (mode === "transfer") {
        return this.accList.filter(acc => !acc.isParent);
      }
      
      // Default: Show all leaf accounts (for journal or other cases where dropdown is shown)
      return this.accList.filter(acc => !acc.isParent);
    },
    // Return filtered accounts based on voucher type for table entries
    filteredAccList() {
      if (!this.accList || this.accList.length === 0) return [];
      const vType = this.saveObj.voucherType;
      const mode = this.currentVoucherMode;
      const isRegularNature = (acc) => {
        const nature = String(acc.nature || "").toLowerCase();
        return (
          (nature === "expense" ||
            nature === "revenue" ||
            nature === "liability" ||
            nature === "asset" ||
            nature === "equity") &&
          !acc.isParent
        );
      };

      // Bank Voucher
      if (vType === "BPV" || vType === "BRV") {
        if (this.allowFlexibleLedgerDrCr) {
          return this.accList.filter(
            (acc) =>
              !acc.isParent &&
              (isRegularNature(acc) || acc.cashFlowCategory === "bank_account")
          );
        }
        return this.accList.filter((acc) => isRegularNature(acc));
      }

      // Cash Voucher
      if (vType === "CPV" || vType === "CRV") {
        if (this.allowFlexibleLedgerDrCr) {
          return this.accList.filter(
            (acc) =>
              !acc.isParent &&
              (isRegularNature(acc) || acc.cashFlowCategory === "cash_account")
          );
        }
        return this.accList.filter((acc) => isRegularNature(acc));
      }

      // Transfer Voucher: Show all accounts
      if (mode === "transfer") {
        return this.accList.filter((acc) => !acc.isParent);
      }

      // Journal Voucher
      if (vType === "JV" && (mode === "journal" || mode === "")) {
        if (this.allowFlexibleLedgerDrCr) {
          return this.accList.filter((acc) => !acc.isParent);
        }
        return this.accList.filter(
          (acc) =>
            acc.cashFlowCategory !== "bank_account" &&
            acc.cashFlowCategory !== "cash_account" &&
            !acc.isParent
        );
      }

      // Default: Show all leaf accounts
      return this.accList.filter((acc) => !acc.isParent);
    },
    // Check if voucher type is bank or credit voucher
    isBankOrCreditVoucher() {
      const vType = this.saveObj.voucherType;
      return vType === "BPV" || vType === "BRV" || vType === "CPV" || vType === "CRV";
    },
    // Check if debit should be disabled (for BRV and CRV)
    isDebitDisabled() {
      if (this.allowFlexibleLedgerDrCr && this.isBankOrCreditVoucher) return false;
      const vType = this.saveObj.voucherType;
      return vType === "BRV" || vType === "CRV";
    },
    // Check if credit should be disabled (for BPV and CPV)
    isCreditDisabled() {
      if (this.allowFlexibleLedgerDrCr && this.isBankOrCreditVoucher) return false;
      const vType = this.saveObj.voucherType;
      return vType === "BPV" || vType === "CPV";
    },
  },
  data() {
    return {
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      rights: {},
      mydocloading: false,
      attachList: [],
      imageLoading: {},
      attachPreviewFailed: {},
      vendorObj: {
        id: 0,
        name: "",
        mobile_number: "",
        campusID: this.$store.state.userData.cId,
      },
      check: 1,
      request: false,
      visibility2: false,
      dataLoading: false,
      visibility: false,
      visibilityVendor: false,
      searchID: "",
      vendorFields: [
        { label: "Name", key: "name" },
        { key: "actions", label: "actions" },
      ],
      typeOptions: [
        { text: "CPV", value: "cpv" },
        { text: "BPV", value: "bpv" },
        { text: "CRV", value: "crv" },
        { text: "BRV", value: "brv" },
        { text: "JV", value: "jv" },
      ],
      accList: [],
      depList: [],
      vendorList: [],
      supplierList: [],
      myObj: [
        {
          id: 0,
          journalEntryID: parseInt(this.$route.params.id),
          accountID: 0,
          debit: 0,
          credit: 0,
          chequeNo: "",
          description: "",
          campusID: this.$store.state.userData.cId,
        },
      ],
      saveObj: {
        id: 0,
        chequeTitle: "",
        voucherNum: 0,
        voucherType: this.$store.state.vType,
        payee: "",
        date: new Date().toJSON(),
        description: "",
        status: "active",
        departmentID: 1,
        vendorID: 0,
        bankAccountID: 0,
        userID: this.$store.state.userData.userID,
        campusID: this.$store.state.userData.cId,
        isReconciled: false,
        chequeBookID: 0,
      },
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      depObj: {
        id: 0,
        name: "",
        campusID: this.$store.state.userData.cId,
      },
      depFields: [
        { label: "Name", key: "name" },
        { key: "actions", label: "actions" },
      ],
      saving: false,
      accIcon: "",
      vtData: [],
      vtSaveData: [],
      autoEntry: null,
      nextVoucherNo: "",
      multiDep: null,
      reviewObj: null,
      accObj: null,
      poLoading: false,
      byGrn: false,
      idList: null,
      grnObj: null,
      supplierObj: null,
      supplierGrns: [],
      grnFields: [
        { label: "ID", key: "id" },
        { label: "quotation ID", key: "quotationID" },
        { label: "Date", key: "date" },
        { label: "Delivery Charges", key: "deliveryCharges" },
        { label: "Total", key: "total" },
        // { label: "Note", key: "note" },
      ],
      selectedList: [],
      showAttachmentsModal: false,
    };
  },

  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),
    inferVoucherMode(voucherType) {
      if (!voucherType) return "journal";
      if (voucherType === "BPV" || voucherType === "BRV") return "bank";
      if (voucherType === "CPV" || voucherType === "CRV") return "credit";
      if (voucherType === "JV") return "journal";
      return "journal";
    },
    getVoucherLastAccountStorageKey(accountKind) {
      const db = this.$store.state.userData?.db || "";
      const cId = this.$store.state.userData?.cId || "";
      return `${VOUCHER_LAST_ACCOUNT_STORAGE_PREFIX}${db}-${cId}-${accountKind}`;
    },
    getVoucherAccountKind() {
      const mode = this.currentVoucherMode;
      if (mode === "bank") return "bank";
      if (mode === "credit") return "cash";
      const vType = this.saveObj?.voucherType;
      if (vType === "BPV" || vType === "BRV") return "bank";
      if (vType === "CPV" || vType === "CRV") return "cash";
      return "";
    },
    getValidVoucherTypesForKind(kind) {
      return kind === "bank" ? ["BPV", "BRV"] : ["CPV", "CRV"];
    },
    readLastVoucherPreferences(kind) {
      try {
        const raw = localStorage.getItem(
          this.getVoucherLastAccountStorageKey(kind)
        );
        if (!raw) return null;

        try {
          const parsed = JSON.parse(raw);
          if (parsed && typeof parsed === "object") {
            return {
              voucherType: parsed.voucherType || "",
              accountID: parseInt(parsed.accountID, 10) || 0,
            };
          }
        } catch (error) {
          // Fall through for legacy plain account-id storage.
        }

        const legacyAccountID = parseInt(raw, 10);
        if (legacyAccountID > 0) {
          return {
            voucherType: kind === "bank" ? "BPV" : "CPV",
            accountID: legacyAccountID,
          };
        }
      } catch (error) {
        console.warn("Unable to read last voucher preferences:", error);
      }
      return null;
    },
    getSavedVoucherType(kind) {
      const prefs = this.readLastVoucherPreferences(kind);
      if (!prefs?.voucherType) return "";
      const validTypes = this.getValidVoucherTypesForKind(kind);
      return validTypes.includes(prefs.voucherType) ? prefs.voucherType : "";
    },
    saveLastVoucherPreferences(updates = {}) {
      if (!this.allowFlexibleLedgerDrCr) return;

      const kind = this.getVoucherAccountKind();
      if (!kind) return;

      const current = this.readLastVoucherPreferences(kind) || {};
      const validTypes = this.getValidVoucherTypesForKind(kind);
      let voucherType =
        updates.voucherType ||
        this.saveObj.voucherType ||
        current.voucherType ||
        validTypes[0];
      if (!validTypes.includes(voucherType)) {
        voucherType = validTypes[0];
      }

      let accountID =
        updates.accountID !== undefined
          ? updates.accountID
          : this.saveObj.bankAccountID || current.accountID || 0;
      accountID = parseInt(accountID, 10) || 0;

      if (accountID > 0) {
        const account = this.getAccountById(accountID);
        const expectedCategory =
          kind === "bank" ? "bank_account" : "cash_account";
        if (
          !account ||
          account.cashFlowCategory !== expectedCategory
        ) {
          if (updates.accountID > 0) return;
          accountID = 0;
        }
      }

      try {
        localStorage.setItem(
          this.getVoucherLastAccountStorageKey(kind),
          JSON.stringify({ voucherType, accountID })
        );
      } catch (error) {
        console.warn("Unable to save last voucher preferences:", error);
      }
    },
    saveLastVoucherAccount(accountID) {
      this.saveLastVoucherPreferences({ accountID });
    },
    restoreLastVoucherAccount() {
      if (!this.allowFlexibleLedgerDrCr) return;
      if (parseInt(this.$route.params.id) !== 0) return;
      if (!this.isBankOrCreditVoucher) return;

      const kind = this.getVoucherAccountKind();
      if (!kind) return;

      try {
        const prefs = this.readLastVoucherPreferences(kind);
        if (!prefs) return;

        if (prefs.accountID > 0 && !this.saveObj.bankAccountID) {
          const exists = this.bankAccountList.some(
            (acc) => acc.id == prefs.accountID || acc.id === prefs.accountID
          );
          if (exists) {
            this.saveObj.bankAccountID = prefs.accountID;
            this.$nextTick(() => {
              this.fetchNextChequeNo();
            });
          }
        }
      } catch (error) {
        console.warn("Unable to restore last voucher account:", error);
      }
    },
    readJournalEditStorage(entryId) {
      const storageKey = `${JOURNAL_EDIT_STORAGE_PREFIX}${entryId}`;
      const cached = sessionStorage.getItem(storageKey);
      if (!cached) return null;

      sessionStorage.removeItem(storageKey);
      try {
        const item = JSON.parse(cached);
        return item?.entry ? item : null;
      } catch (error) {
        console.error("Failed to parse stored journal edit data:", error);
        return null;
      }
    },
    async loadEntryForEdit(entryId) {
      const cID = this.$store.state.userData.cId;
      const db = this.$store.state.userData.db;
      const findMatch = (items) => {
        if (!Array.isArray(items)) return null;
        return items.find((row) => row.entry && row.entry.id == entryId) || null;
      };

      try {
        const searchRes = await this.get({
          url:
            this.$store.state.domain +
            "JournalEntry/Search?db=" +
            db +
            "&cID=" +
            cID +
            "&keyword=" +
            entryId,
          token: this.$store.state.userData.token,
        });
        const searchMatch = findMatch(searchRes);
        if (searchMatch) {
          this.saveObj = searchMatch.entry;
          this.myObj = searchMatch.details || [];
          return true;
        }
      } catch (error) {
        console.error("Journal entry search failed:", error);
      }

      try {
        const paginationRes = await this.get({
          url:
            this.$store.state.domain +
            "JournalEntry/LoadDataPagination?cID=" +
            cID +
            "&db=" +
            db +
            "&dtFrom=&dtTo=&page=1",
          token: this.$store.state.userData.token,
          dashboard: true,
        });
        const payload = paginationRes?.data || paginationRes;
        const items = Array.isArray(payload) ? payload : payload.data || [];
        const paginationMatch = findMatch(items);
        if (paginationMatch) {
          this.saveObj = paginationMatch.entry;
          this.myObj = paginationMatch.details || [];
          return true;
        }
      } catch (error) {
        console.error("Journal entry pagination load failed:", error);
      }

      try {
        const loadRes = await this.get({
          url:
            this.$store.state.domain +
            "JournalEntry/LoadData?db=" +
            db +
            "&cID=" +
            cID +
            "&id=" +
            entryId,
          token: this.$store.state.userData.token,
        });
        const payload = loadRes?.data || loadRes;
        if (payload?.entry) {
          this.saveObj = payload.entry;
          this.myObj = payload.details || [];
          return true;
        }
      } catch (error) {
        console.error("Journal entry load failed:", error);
      }

      this.$bvToast.toast(this.$t("Unable to load voucher for editing."), {
        title: this.$t("Error"),
        variant: "danger",
        solid: true,
      });
      return false;
    },
    async initializeEditEntry() {
      // Set isReconciled if not present in loaded data
      if (this.saveObj.isReconciled === undefined || this.saveObj.isReconciled === null) {
        const vType = this.saveObj.voucherType;
        this.saveObj.isReconciled = (vType === "BPV" || vType === "BRV") ? false : true;
      }

      await this.LoadAccounts();

      if (!this.saveObj.bankAccountID || this.saveObj.bankAccountID === 0) {
        const vType = this.saveObj.voucherType;
        if (vType === "BPV" || vType === "BRV" || vType === "CPV" || vType === "CRV") {
          for (const entry of this.myObj) {
            const acc = this.accList.find(a => a.id === entry.accountID);
            if (acc) {
              if ((vType === "BPV" || vType === "BRV") && acc.cashFlowCategory === "bank_account") {
                this.saveObj.bankAccountID = acc.id;
                break;
              }
              if ((vType === "CPV" || vType === "CRV") && acc.cashFlowCategory === "cash_account") {
                this.saveObj.bankAccountID = acc.id;
                break;
              }
            }
          }
        }
      }

      // Auto-fill narration and cheque number from bank account entry if it exists
      if (this.saveObj.bankAccountID > 0) {
        const bankEntry = this.myObj.find(entry => entry.accountID === this.saveObj.bankAccountID);
        if (bankEntry) {
          // Auto-fill narration from bank account entry description
          if (bankEntry.description && !this.saveObj.description) {
            this.saveObj.description = bankEntry.description;
          }
          // Auto-fill cheque number from bank account entry chequeNo
          if (bankEntry.chequeNo && !this.saveObj.chequeTitle) {
            this.saveObj.chequeTitle = bankEntry.chequeNo;
          }

          if (this.allowFlexibleLedgerDrCr) {
            const hasAmount =
              (parseFloat(bankEntry.debit) || 0) > 0 ||
              (parseFloat(bankEntry.credit) || 0) > 0;
            if (hasAmount && parseInt(this.$route.params.id) > 0) {
              this.$set(bankEntry, "ledgerAmountLocked", true);
            }
          }
        }

        if (
          !(
            this.allowFlexibleLedgerDrCr && this.isBankOrCreditVoucher
          )
        ) {
          this.$nextTick(() => {
            const vType = this.saveObj.voucherType;
            if (vType === "BPV" || vType === "BRV") {
              this.autoBalanceBankVoucher();
            } else if (vType === "CPV" || vType === "CRV") {
              this.autoBalanceCreditVoucher();
            }
          });
        }
      }

      if (this.allowFlexibleLedgerDrCr && this.isBankOrCreditVoucher) {
        this.lockLoadedFlexibleLedgerRows();
      }

      this.attachList = parseDocUrls(this.saveObj.attachments);
      this.loadDeps();
      this.loadVtSettings();
      this.LoadSettings();
      this.LoadSettingsAll();
      this.loadVendors();
    },

    // Get date column size based on mode
    getDateColumnSize() {
      if (this.currentVoucherMode === 'journal' || this.currentVoucherMode === 'transfer') {
        return '3'; // Date (3), Reference (3), Narration (3) = 9, remaining 3 for spacing
      }
      if (this.showVoucherTypeDropdown) {
        if (this.currentVoucherMode === 'bank' || this.currentVoucherMode === 'credit') {
          return '2'; // Voucher Type (2), Date (2), Bank Account (3), Reference (5) = 12
        }
        return '2'; // Voucher Type (2), Date (2), Reference (8) = 12
      }
      if (this.currentVoucherMode === 'bank' || this.currentVoucherMode === 'credit') {
        return '2'; // Date (2), Bank Account (3), Reference (7) = 12
      }
      return '3'; // Date, Reference
    },
    // Get bank account column size
    getBankAccountColumnSize() {
      if (this.currentVoucherMode === 'bank' || this.currentVoucherMode === 'credit') {
        if (this.showVoucherTypeDropdown) {
          return '3'; // Voucher Type (2), Date (2), Bank Account (3), Reference (5) = 12
        }
        return '3'; // Date (2), Bank Account (3), Reference (7) = 12
      }
      return '3';
    },
    // Get cheque column size
    getChequeColumnSize() {
      if (this.currentVoucherMode === 'journal' || this.currentVoucherMode === 'transfer') {
        return '3'; // Date (3), Reference (3), Narration (3) = 9, remaining 3 for spacing
      }
      if (this.currentVoucherMode === 'bank') {
        if (this.showVoucherTypeDropdown) {
          return '5'; // Voucher Type (2), Date (2), Bank Account (3), Reference (5) = 12
        }
        return '7'; // Date (2), Bank Account (3), Reference (7) = 12
      }
      if (this.currentVoucherMode === 'credit') {
        if (this.showVoucherTypeDropdown) {
          return '5'; // Voucher Type (2), Date (2), Bank Account (3), Reference (5) = 12
        }
        return '7'; // Date (2), Bank Account (3), Reference (7) = 12
      }
      return '3';
    },
    // Get narration column size
    getNarrationColumnSize() {
      if (this.currentVoucherMode === 'journal' || this.currentVoucherMode === 'transfer') {
        // Date (3) + Reference (3) + Payee (3) + Narration (3) = 12 columns
        return '3';
      }
      return '12';
    },
    // Get payee column size
    getPayeeColumnSize() {
      if (this.currentVoucherMode === 'journal' || this.currentVoucherMode === 'transfer') {
        return '3';
      }
      return '12';
    },
    isPreviewableAttach(file) {
      const url = this.getAttachUrl(file);
      if (this.attachPreviewFailed[url]) return false;
      return checkPreviewableDoc(file);
    },
    getAttachPreviewUrl(file) {
      return resolveDocPreviewUrl(file);
    },
    getAttachUrl(file) {
      return resolveDocUrl(file);
    },
    handleAttachPreviewError(event, file) {
      const url = this.getAttachUrl(file);
      handleDrivePreviewError(event, url, "image");
      const img = event?.target;
      const tried = img?.getAttribute("data-preview-index");
      const nextIndex = tried === null ? 1 : Number(tried) + 1;
      const candidates = getDriveImagePreviewCandidates(url);
      if (!candidates[nextIndex]) {
        this.$set(this.attachPreviewFailed, url, true);
      }
    },
    getFileName(file, index) {
      return getDocumentDisplayName(this.getAttachUrl(file), index);
    },
    onAttachImageLoadStart(file) {
      this.$set(this.imageLoading, this.getAttachUrl(file), true);
    },
    onAttachImageLoad(file) {
      this.$set(this.imageLoading, this.getAttachUrl(file), false);
    },
    async setCurrentDate() {
      var obj = {
        url: this.$store.state.domain + "Fees/GetDate",
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);

      // console.log(res);
      if (res && !Array.isArray(res)) {
        this.saveObj.date = res;
      } else {
        this.saveObj.date = new Date().toJSON();
      }
    },

    async fetchNextVoucherNo() {
      if (parseInt(this.$route.params.id) !== 0) return;

      const voucherType = (this.saveObj.voucherType || "").trim();
      if (!voucherType) {
        this.nextVoucherNo = "";
        return;
      }

      try {
        const obj = {
          url:
            this.$store.state.domain +
            "JournalEntry/GetNextVoucherNo?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&voucherType=" +
            encodeURIComponent(voucherType),
          token: this.$store.state.userData.token,
          returnData: true,
        };
        const res = await this.get(obj);
        if (res && res.status === "success") {
          this.nextVoucherNo =
            res.voucherNo ||
            (res.voucherType && res.voucherNum != null
              ? `${res.voucherType}${res.voucherNum}`
              : "");
        } else {
          this.nextVoucherNo = "";
        }
      } catch (e) {
        console.warn("GetNextVoucherNo failed:", e);
        this.nextVoucherNo = "";
      }
    },

    async fetchNextChequeNo() {
      if (this.currentVoucherMode === 'bank' && this.saveObj.bankAccountID) {
        var obj = {
          url:
            this.$store.state.domain +
            "chequeBooks/GetNextChequeNo?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&accountID=" +
            this.saveObj.bankAccountID,
          token: this.$store.state.userData.token,
          returnData: true,
        };
        let res = await this.get(obj);
        if (res && res.status === "success" && res.nextChequeNo) {
          // Only auto-fill if the number is not 0
          if (res.nextChequeNo != "0" && res.nextChequeNo != 0) {
            this.saveObj.chequeTitle = res.nextChequeNo.toString();
            // Store chequeBookID only for Bank Vouchers
            if (this.currentVoucherMode === 'bank') {
              this.saveObj.chequeBookID = res.chequeBookID || 0;
            }
          }
        }
      }
    },

    async checkGrnID() {
      let x = parseInt(this.searchID);
      if (isNaN(x) || x <= 0) {
        this.$bvToast.toast("Please enter the GRN ID.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }
      this.searchID = x;
      this.poLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "JournalEntry/LoadGrn?db=" +
          this.$store.state.userData.db +
          "&grnID=" +
          this.searchID,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      // console.log(res);
      if (res?.grn && res.data.length > 0) {
        this.byGrn = true;
        this.grnObj = res.grn;
        this.supplierObj = null;
        this.selectedList = [];
        this.myObj = res.data.map((el) => ({
          id: 0,
          journalEntryID: parseInt(this.$route.params.id),
          accountID: el.pd.accountID,
          debit: el.gd.totalPrice,
          credit: 0,
          chequeNo: "",
          description: el.pd.name,
          campusID: this.$store.state.userData.cId,
        }));
        if (this.idList) {
          if (res.grn.deliveryCharges > 0 && this.idList.value) {
            this.myObj.push({
              id: 0,
              journalEntryID: parseInt(this.$route.params.id),
              accountID: parseInt(this.idList.value),
              debit: res.grn.deliveryCharges,
              credit: 0,
              chequeNo: "",
              description: "Delivery Charges",
              campusID: this.$store.state.userData.cId,
            });
          }
          if (this.idList.valueNumber) {
            this.myObj.push({
              id: 0,
              journalEntryID: parseInt(this.$route.params.id),
              accountID: this.idList.valueNumber,
              debit: 0,
              credit: res.grn.total,
              chequeNo: "",
              description: "Uninvoiced",
              campusID: this.$store.state.userData.cId,
            });
          }
        }
      } else {
        this.$bvToast.toast(this.$t("No records found"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        this.byGrn = false;
        this.grnObj = null;
        this.supplierObj = null;
        this.selectedList = [];
        this.myObj = [
          {
            id: 0,
            journalEntryID: parseInt(this.$route.params.id),
            accountID: 0,
            debit: 0,
            credit: 0,
            chequeNo: "",
            description: "",
            campusID: this.$store.state.userData.cId,
          },
        ];
      }
      this.poLoading = false;
    },
    async getGrn() {
      // console.log(this.supplierObj);
      this.grnObj = null;
      this.byGrn = false;
      this.selectedList = [];
      if (this.supplierObj) {
        this.poLoading = true;
        var obj = {
          url:
            this.$store.state.domain +
            "goodsReceivingNote/LoadByVendor?db=" +
            this.$store.state.userData.db +
            "&vendorID=" +
            this.supplierObj.id,
          token: this.$store.state.userData.token,
        };
        this.supplierGrns = await this.get(obj);
        // console.log(this.supplierGrns);
        if (this.supplierGrns.length > 0) {
          this.$bvModal.show("modal-grn");
        } else {
          this.$bvToast.toast(this.$t("No records found"), {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        }
        this.poLoading = false;
      } else {
        this.myObj = [
          {
            id: 0,
            journalEntryID: parseInt(this.$route.params.id),
            accountID: 0,
            debit: 0,
            credit: 0,
            chequeNo: "",
            description: "",
            campusID: this.$store.state.userData.cId,
          },
        ];
      }
    },
    selectGrn(rows) {
      this.selectedList = rows;
      // console.log(this.selectedList);
    },
    confirmGrn() {
      const gTotal = this.selectedList.reduce(
        (acc, item) => acc + item.total,
        0
      );
      if (this.idList) {
        this.myObj = [
          {
            id: 0,
            journalEntryID: parseInt(this.$route.params.id),
            accountID: this.idList.valueNumber,
            debit: gTotal,
            credit: 0,
            chequeNo: "",
            description: "Uninvoiced",
            campusID: this.$store.state.userData.cId,
          },
        ];
      }
      this.myObj.push({
        id: 0,
        journalEntryID: parseInt(this.$route.params.id),
        accountID: this.supplierObj.accountID,
        debit: 0,
        credit: gTotal,
        chequeNo: "",
        description: this.supplierObj.name,
        campusID: this.$store.state.userData.cId,
      });
      this.$bvModal.hide("modal-grn");
    },
    async PsampleAdd() {
      if (this.$refs.psamplefile.files.length !== 0) {
        this.mydocloading = true;
        const fileList = Array.from(this.$refs.psamplefile.files);
        try {
          const uploaded = await uploadToMySkool(fileList);
          uploaded.forEach((el, index) => {
            const sourceFile = fileList[index];
            const attachment = buildUploadedAttachment({
              ...el,
              mimetype: el.mimetype || sourceFile?.type,
              originalname: el.originalname || sourceFile?.name,
            });
            this.attachList.push(attachment);
          });
          this.saveObj.attachments = serializeDocUrls(this.attachList);
        } catch (error) {
          console.log(error);
        } finally {
          this.mydocloading = false;
          if (this.$refs.psamplefile) this.$refs.psamplefile.value = "";
        }
      }
    },
    deleteDocument(index) {
      this.attachList.splice(index, 1);
      this.saveObj.attachments = serializeDocUrls(this.attachList);
    },
    openFile(url) {
      window.open(resolveDocUrl(url), "_blank");
    },
    handleEvent(event) {
      // console.log(event);
      if (event.ctrlKey && event.keyCode === 83) {
        event.preventDefault();
        if (this.check == 1) {
          this.check = 0;
          this.Add();
        }
      }
    },
    setVT() {
      this.$store.commit("setVType", this.saveObj.voucherType);
    },

    async LoadSettings() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["accounts_multi_department", "accounts_grn"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.multiDep = res.find((el) => el.key == "accounts_multi_department");
      this.idList = res.find((el) => el.key == "accounts_grn");
      // console.log(this.multiDep);
    },
    async LoadSettingsAll() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["inventory_account", "journal_entry_review"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      // console.log(res);
      this.accObj = res.find((el) => el.key == "inventory_account");
      this.reviewObj = res.find((el) => el.key == "journal_entry_review");

      if (this.accObj?.valueBool) {
        this.LoadSupplier();
      }
    },
    async LoadSupplier() {
      var obj = {
        url:
          this.$store.state.domain +
          "posSupplier?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.supplierList = await this.get(obj);
    },

    async loadVtSettings() {
      var obj = {
        url:
          this.$store.state.domain +
          "VoucherAccounts/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.vtData = await this.get(obj);
      // console.log(this.vtData);
    },
    openVtSettings() {
      this.visibility2 = true;
      if (this.vtData.length == 0) {
        this.vtSaveData = [
          {
            id: 0,
            voucherType: "CPV",
            accountID: 0,
            campusID: this.$store.state.userData.cId,
          },
          {
            id: 0,
            voucherType: "BPV",
            accountID: 0,
            campusID: this.$store.state.userData.cId,
          },
          {
            id: 0,
            voucherType: "CRV",
            accountID: 0,
            campusID: this.$store.state.userData.cId,
          },
          {
            id: 0,
            voucherType: "BRV",
            accountID: 0,
            campusID: this.$store.state.userData.cId,
          },
        ];
      } else this.vtSaveData = [...this.vtData];
    },
    setAutoAccount() {
      let obj = this.vtData.find(
        (el) => el.voucherType == this.saveObj.voucherType
      );
      // console.log(obj);
      if (
        obj &&
        obj.accountID != 0 &&
        obj.accountID != null &&
        obj.accountID != ""
      ) {
        this.autoEntry = {
          id: 0,
          journalEntryID: parseInt(this.$route.params.id),
          accountID: obj.accountID,
          debit: 0,
          credit: 0,
          chequeNo: "",
          description: "",
          campusID: this.$store.state.userData.cId,
        };

        if (
          this.saveObj.voucherType == "CPV" ||
          this.saveObj.voucherType == "BPV"
        ) {
          this.autoEntry.credit = this.totalDebit - this.totalCredit;
        } else if (
          this.saveObj.voucherType == "CRV" ||
          this.saveObj.voucherType == "BRV"
        ) {
          this.autoEntry.debit = this.totalCredit - this.totalDebit;
        }
        // console.log(this.autoEntry);
      } else this.autoEntry = null;
    },

    async saveVtSettings() {
      this.saving = true;
      this.vtSaveData.forEach((el) => {
        if (el.accountID == null || el.accountID == "") el.accountID = 0;
      });
      // console.log(this.vtSaveData);
      var status = await this.post({
        url:
          this.$store.state.domain +
          "VoucherAccounts/SaveData?db=" +
          this.$store.state.userData.db,
        body: this.vtSaveData,
        message: "Setting saved successfully.",
        context: this,
        token: this.$store.state.userData.token,
      });
      this.saving = false;
      if (status) {
        this.loadVtSettings();
        this.visibility2 = false;
      }
    },

    openDep() {
      this.accIcon = "PlusIcon";
      this.visibility = true;
      this.depObj = {
        id: 0,
        name: "",
        campusID: this.$store.state.userData.cId,
      };
      var elem = this.$refs["dep_name"];
      elem.state = undefined;
    },
    openVendor() {
      this.accIcon = "PlusIcon";
      this.visibilityVendor = true;
      this.vendorObj = {
        id: 0,
        name: "",
        mobile_number: "",
        campusID: this.$store.state.userData.cId,
      };
      var elem = this.$refs["vendor_name"];
      elem.state = undefined;
    },
    CheckName() {
      var elem = this.$refs["dep_name"];
      if (this.depObj.name.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckVendorName() {
      var elem = this.$refs["vendor_name"];
      if (this.vendorObj.name.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async addDep() {
      if (this.CheckName() == true) {
        this.saving = true;
        // console.log(this.depObj);
        if (this.depObj.id == 0) {
          var status = await this.post({
            url:
              this.$store.state.domain +
              "AccountsDepartment?db=" +
              this.$store.state.userData.db,
            body: this.depObj,
            message: "Department added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          var status = await this.put({
            url:
              this.$store.state.domain +
              "AccountsDepartment/" +
              this.depObj.id +
              "?db=" +
              this.$store.state.userData.db,
            message: "Department updated successfully.",
            context: this,
            body: this.depObj,
            token: this.$store.state.userData.token,
          });
        }
        if (status) {
          this.loadDeps();
          var elem = this.$refs["dep_name"];
          elem.state = undefined;
          this.accIcon = "PlusIcon";
          this.depObj = {
            id: 0,
            name: "",
            campusID: this.$store.state.userData.cId,
          };
        }
        this.saving = false;
      }
    },
    async Edit(item) {
      this.depObj = { ...item };
      this.accIcon = "Edit2Icon";
      var elem = this.$refs["dep_name"];
      elem.state = undefined;
      // console.log(this.depObj);
    },

    async Delete(id) {
      // console.log(id);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "AccountsDepartment/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          message: "Department deleted successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.loadDeps();
      }
    },
    async addVendor() {
      if (this.CheckVendorName() == true) {
        this.saving = true;
        // console.log(this.depObj);
        if (this.vendorObj.id == 0) {
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Vendors?db=" +
              this.$store.state.userData.db,
            body: this.vendorObj,
            message: "Vendor added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          var status = await this.put({
            url:
              this.$store.state.domain +
              "Vendors/" +
              this.vendorObj.id +
              "?db=" +
              this.$store.state.userData.db,
            message: "Vendor updated successfully.",
            context: this,
            body: this.vendorObj,
            token: this.$store.state.userData.token,
          });
        }
        if (status) {
          this.loadVendors();
          var elem = this.$refs["vendor_name"];
          elem.state = undefined;
          this.accIcon = "PlusIcon";
          this.vendorObj = {
            id: 0,
            name: "",
            mobile_number: "",
            campusID: this.$store.state.userData.cId,
          };
        }
        this.saving = false;
      }
    },
    async EditVendor(item) {
      //console.log(item);
      this.vendorObj = { ...item };
      this.accIcon = "Edit2Icon";
      var elem = this.$refs["vendor_name"];
      elem.state = undefined;
    },
    async DeleteVendor(id) {
      // console.log(id);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "Vendors/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          message: "Vendor deleted successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.loadVendors();
      }
    },
    dropFilter(opt, label, search) {
      // console.log(opt, label, search);
      let st = search.toLowerCase();
      return (
        (opt.title && opt.title.toLowerCase().match(st)) ||
        (opt.code && opt.code.toLowerCase().match(st))
      );
    },
    AddValue(item, ind) {
      const newEntry = {
        id: 0,
        journalEntryID: parseInt(this.$route.params.id),
        accountID: 0,
        debit: 0,
        credit: 0,
        chequeNo: "",
        description: "",
        campusID: this.$store.state.userData.cId,
      };

      if (this.allowFlexibleLedgerDrCr && this.isBankOrCreditVoucher) {
        this.myObj.push(newEntry);
        this.$nextTick(() => {
          const newInd = this.myObj.length - 1;
          const elem = document.getElementById("debit" + newInd);
          if (elem) {
            elem.focus();
            elem.select();
          }
        });
        return;
      }

      const bankIndex = this.myObj.findIndex(
        (entry, index) => this.isBankAccountEntry(entry, index)
      );

      if (this.isBankOrCreditVoucher && bankIndex >= 0) {
        this.myObj.splice(bankIndex, 0, newEntry);
      } else {
        this.myObj.push(newEntry);
      }

      this.$nextTick(() => {
        this.rebalanceBankOrCreditVoucher();

        setTimeout(() => {
          let newInd = bankIndex >= 0 ? bankIndex : this.myObj.length - 1;
          let elem = document.getElementById("debit" + newInd);
          if (elem) {
            elem.focus();
            elem.select();
          }
        }, 100);
      });
    },
    async removeValue(item, ind) {
      if (this.isBankAccountEntry(item, ind)) {
        return;
      }

      if (item.id == 0) {
        this.myObj.splice(ind, 1);
      } else {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "JournalEntry/DeleteEntry?cID=" +
            this.$store.state.userData.cId +
            "&db=" +
            this.$store.state.userData.db +
            "&detailID=" +
            item.id,
          grading: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.myObj.splice(ind, 1);
      }

      this.$nextTick(() => {
        if (this.allowFlexibleLedgerDrCr && this.isBankOrCreditVoucher) {
          this.syncFlexibleHeaderBankAmounts();
        } else {
          this.rebalanceBankOrCreditVoucher();
        }
      });
    },
    isLastEditableEntryRow(ind) {
      if (this.isBankAccountEntry(this.myObj[ind], ind)) {
        return false;
      }

      for (let i = this.myObj.length - 1; i >= 0; i--) {
        if (!this.isBankAccountEntry(this.myObj[i], i)) {
          return i === ind;
        }
      }

      return ind === this.myObj.length - 1;
    },
    canRemoveEntry(item, ind) {
      if (this.isBankAccountEntry(item, ind)) {
        return false;
      }

      const editableCount = this.myObj.filter(
        (entry, index) => !this.isBankAccountEntry(entry, index)
      ).length;

      return editableCount > 1;
    },
    rebalanceBankOrCreditVoucher() {
      if (this.allowFlexibleLedgerDrCr && this.isBankOrCreditVoucher) {
        return;
      }
      const vType = this.saveObj.voucherType;
      if ((vType === "BPV" || vType === "BRV") && this.saveObj.bankAccountID > 0) {
        this.autoBalanceBankVoucher();
      } else if (
        (vType === "CPV" || vType === "CRV") &&
        this.saveObj.bankAccountID > 0
      ) {
        this.autoBalanceCreditVoucher();
      }
    },
    addNewEntry() {
      this.myObj.push({
        id: 0,
        journalEntryID: parseInt(this.$route.params.id),
        accountID: 0,
        debit: 0,
        credit: 0,
        chequeNo: "",
        description: "",
        campusID: this.$store.state.userData.cId,
      });
    },
    formatNumber(num) {
      if (!num && num !== 0) return "0.00";
      return parseFloat(num).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    isRowDebitDisabled(item, ind) {
      if (this.byGrn) return true;
      if (
        this.isBankOrCreditVoucher &&
        (this.isBankOrCashAccount(item.accountID) ||
          this.isBankAccountEntry(item, ind))
      ) {
        return (parseFloat(item.credit) || 0) > 0;
      }
      if (this.allowFlexibleLedgerDrCr && this.isBankOrCreditVoucher) {
        return (parseFloat(item.credit) || 0) > 0;
      }
      return (
        (parseFloat(item.credit) || 0) > 0 || this.isDebitDisabled
      );
    },
    isRowCreditDisabled(item, ind) {
      if (this.byGrn) return true;
      if (
        this.isBankOrCreditVoucher &&
        (this.isBankOrCashAccount(item.accountID) ||
          this.isBankAccountEntry(item, ind))
      ) {
        return (parseFloat(item.debit) || 0) > 0;
      }
      if (this.allowFlexibleLedgerDrCr && this.isBankOrCreditVoucher) {
        return (parseFloat(item.debit) || 0) > 0;
      }
      return (
        (parseFloat(item.debit) || 0) > 0 || this.isCreditDisabled
      );
    },
    handleDebitCreditChange(item, ind) {
      const debitValue = parseFloat(item.debit) || 0;
      const creditValue = parseFloat(item.credit) || 0;
      const vType = this.saveObj.voucherType;

      if (
        this.isBankOrCreditVoucher &&
        (this.isBankAccountEntry(item, ind) ||
          this.isBankOrCashAccount(item.accountID))
      ) {
        this.$set(item, "ledgerAmountLocked", true);
        if (this.allowFlexibleLedgerDrCr) {
          return;
        }
        return;
      }

      if (this.allowFlexibleLedgerDrCr && this.isBankOrCreditVoucher) {
        this.$nextTick(() => {
          this.syncFlexibleHeaderBankAmounts();
        });
        return;
      }

      if (!(this.allowFlexibleLedgerDrCr && this.isBankOrCreditVoucher)) {
        // Enforce voucher type restrictions
        // For BPV/CPV: Only debit allowed, clear credit
        if (vType === "BPV" || vType === "CPV") {
          if (creditValue > 0) {
            item.credit = 0;
          }
        }
        // For BRV/CRV: Only credit allowed, clear debit
        else if (vType === "BRV" || vType === "CRV") {
          if (debitValue > 0) {
            item.debit = 0;
          }
        }
        // For other voucher types (JV, etc.): If debit has value, clear credit and vice versa
        else {
          // If debit has a value > 0, clear credit
          if (debitValue > 0) {
            if (creditValue > 0) {
              item.credit = 0;
            }
          }
          // If credit has a value > 0, clear debit
          else if (creditValue > 0) {
            if (debitValue > 0) {
              item.debit = 0;
            }
          }
        }
      }

      // Auto-balance for Bank Vouchers (BPV/BRV) - use nextTick to ensure data is updated
      this.$nextTick(() => {
        const bankEntry = this.myObj.find(
          (entry) => entry.accountID === this.saveObj.bankAccountID
        );
        if (bankEntry && bankEntry.ledgerAmountLocked) {
          return;
        }

        if ((vType === "BPV" || vType === "BRV") && this.saveObj.bankAccountID > 0) {
          this.autoBalanceBankVoucher();
        }
        
        // Auto-balance for Credit Vouchers (CPV/CRV)
        if ((vType === "CPV" || vType === "CRV") && this.saveObj.bankAccountID > 0) {
          this.autoBalanceCreditVoucher();
        }
      });
    },
    lockLoadedFlexibleLedgerRows() {
      if (parseInt(this.$route.params.id) === 0) return;
      this.myObj.forEach((row) => {
        if (!this.isBankOrCashAccount(row.accountID)) return;
        const hasAmount =
          (parseFloat(row.debit) || 0) > 0 ||
          (parseFloat(row.credit) || 0) > 0;
        if (hasAmount) {
          this.$set(row, "ledgerAmountLocked", true);
        }
      });
    },
    isBankOrCashAccount(accountID) {
      const account = this.getAccountById(accountID);
      if (!account) return false;
      const vType = this.saveObj.voucherType;
      const isBankVoucher = vType === "BPV" || vType === "BRV";
      const isCashVoucher = vType === "CPV" || vType === "CRV";
      return (
        (isBankVoucher && account.cashFlowCategory === "bank_account") ||
        (isCashVoucher && account.cashFlowCategory === "cash_account")
      );
    },
    autoFillFlexibleLedgerRow(item, rowIndex) {
      if (item.ledgerAmountLocked) return;

      const totalDebit = this.myObj.reduce((sum, entry, index) => {
        if (index === rowIndex) return sum;
        return sum + (parseFloat(entry.debit) || 0);
      }, 0);

      const totalCredit = this.myObj.reduce((sum, entry, index) => {
        if (index === rowIndex) return sum;
        return sum + (parseFloat(entry.credit) || 0);
      }, 0);

      item.debit = 0;
      item.credit = 0;

      if (totalDebit > 0) {
        item.credit = totalDebit;
      } else if (totalCredit > 0) {
        item.debit = totalCredit;
      }
    },
    syncFlexibleHeaderBankRow(newVal, oldVal) {
      if (!this.isBankOrCreditVoucher) return;

      if (oldVal > 0 && newVal !== oldVal) {
        const oldIdx = this.myObj.findIndex(
          (entry) => entry.accountID === oldVal && entry.id === 0
        );
        if (oldIdx >= 0 && this.myObj.length > 1) {
          this.myObj.splice(oldIdx, 1);
        }
      }

      if (!newVal || newVal <= 0) return;

      let bankRow = this.myObj.find((entry) => entry.accountID === newVal);
      if (!bankRow) {
        bankRow = {
          id: 0,
          journalEntryID: parseInt(this.$route.params.id),
          accountID: newVal,
          debit: 0,
          credit: 0,
          chequeNo: this.saveObj.chequeTitle || "",
          description: this.saveObj.description || "Bank Account",
          campusID: this.$store.state.userData.cId,
        };
        this.myObj.push(bankRow);
        this.$set(bankRow, "ledgerAmountLocked", false);
      } else if (newVal !== oldVal) {
        this.$set(bankRow, "ledgerAmountLocked", false);
      }

      bankRow.chequeNo = this.saveObj.chequeTitle || bankRow.chequeNo || "";
      if (!bankRow.description || bankRow.description === "Bank Account") {
        bankRow.description = this.saveObj.description || "Bank Account";
      }

      const rowIndex = this.myObj.indexOf(bankRow);
      this.$nextTick(() => {
        this.autoFillFlexibleLedgerRow(bankRow, rowIndex);
      });
    },
    syncFlexibleHeaderBankAmounts() {
      if (!this.allowFlexibleLedgerDrCr || !this.isBankOrCreditVoucher) return;
      if (!this.saveObj.bankAccountID || this.saveObj.bankAccountID <= 0) return;

      let bankRow = this.myObj.find(
        (entry) => entry.accountID === this.saveObj.bankAccountID
      );
      if (!bankRow) {
        this.syncFlexibleHeaderBankRow(this.saveObj.bankAccountID, 0);
        return;
      }
      if (bankRow.ledgerAmountLocked) return;

      const rowIndex = this.myObj.indexOf(bankRow);
      this.autoFillFlexibleLedgerRow(bankRow, rowIndex);
    },
    autoBalanceBankVoucher() {
      // For BPV/BRV: Auto-balance bank account based on debit or credit amounts
      if (this.saveObj.bankAccountID > 0) {
        // Calculate totals from all entries (excluding bank account entry)
        const totalDebit = this.myObj
          .filter(entry => entry.accountID !== this.saveObj.bankAccountID)
          .reduce((sum, entry) => sum + (parseFloat(entry.debit) || 0), 0);
        
        const totalCredit = this.myObj
          .filter(entry => entry.accountID !== this.saveObj.bankAccountID)
          .reduce((sum, entry) => sum + (parseFloat(entry.credit) || 0), 0);
        
        // Find if bank account entry already exists
        let bankEntry = this.myObj.find(entry => entry.accountID === this.saveObj.bankAccountID);
        
        // Determine which side to put bank account based on what has amounts
        const hasAmounts = totalDebit > 0 || totalCredit > 0;
        
        if (hasAmounts) {
          if (bankEntry) {
            // Update existing bank account entry
            if (totalDebit > 0) {
              if (!bankEntry.ledgerAmountLocked) {
                bankEntry.credit = totalDebit;
                bankEntry.debit = 0;
              }
            } else if (totalCredit > 0) {
              if (!bankEntry.ledgerAmountLocked) {
                bankEntry.debit = totalCredit;
                bankEntry.credit = 0;
              }
            }
            // Update narration and cheque number from saveObj
            bankEntry.chequeNo = this.saveObj.chequeTitle || "";
            bankEntry.description = this.saveObj.description || "Bank Account";
          } else {
            // Add new bank account entry
            if (totalDebit > 0) {
              // If debit amounts exist, bank account goes in credit
              this.myObj.push({
                id: 0,
                journalEntryID: parseInt(this.$route.params.id),
                accountID: this.saveObj.bankAccountID,
                debit: 0,
                credit: totalDebit,
                chequeNo: this.saveObj.chequeTitle || "",
                description: this.saveObj.description || "Bank Account",
                campusID: this.$store.state.userData.cId,
              });
            } else if (totalCredit > 0) {
              // If credit amounts exist, bank account goes in debit
              this.myObj.push({
                id: 0,
                journalEntryID: parseInt(this.$route.params.id),
                accountID: this.saveObj.bankAccountID,
                debit: totalCredit,
                credit: 0,
                chequeNo: this.saveObj.chequeTitle || "",
                description: this.saveObj.description || "Bank Account",
                campusID: this.$store.state.userData.cId,
              });
            }
          }
        } else {
          // Remove bank account entry if no amounts
          if (bankEntry && bankEntry.id === 0 && this.myObj.length > 1) {
            const bankEntryIndex = this.myObj.findIndex(entry => entry.accountID === this.saveObj.bankAccountID && entry.id === 0);
            if (bankEntryIndex >= 0) {
              this.myObj.splice(bankEntryIndex, 1);
            }
          }
        }
      }
    },
    autoBalanceCreditVoucher() {
      // For CPV/CRV: Auto-balance bank account based on debit or credit amounts
      if (this.saveObj.bankAccountID > 0) {
        // Calculate totals from all entries (excluding bank account entry)
        const totalDebit = this.myObj
          .filter(entry => entry.accountID !== this.saveObj.bankAccountID)
          .reduce((sum, entry) => sum + (parseFloat(entry.debit) || 0), 0);
        
        const totalCredit = this.myObj
          .filter(entry => entry.accountID !== this.saveObj.bankAccountID)
          .reduce((sum, entry) => sum + (parseFloat(entry.credit) || 0), 0);
        
        // Find if bank account entry already exists
        let bankEntry = this.myObj.find(entry => entry.accountID === this.saveObj.bankAccountID);
        
        // Determine which side to put bank account based on what has amounts
        const hasAmounts = totalDebit > 0 || totalCredit > 0;
        
        if (hasAmounts) {
          if (bankEntry) {
            // Update existing bank account entry
            if (totalDebit > 0) {
              if (!bankEntry.ledgerAmountLocked) {
                bankEntry.credit = totalDebit;
                bankEntry.debit = 0;
              }
            } else if (totalCredit > 0) {
              if (!bankEntry.ledgerAmountLocked) {
                bankEntry.debit = totalCredit;
                bankEntry.credit = 0;
              }
            }
            // Update narration and cheque number from saveObj
            bankEntry.chequeNo = this.saveObj.chequeTitle || "";
            bankEntry.description = this.saveObj.description || "Bank Account";
          } else {
            // Add new bank account entry
            if (totalDebit > 0) {
              // If debit amounts exist, bank account goes in credit
              this.myObj.push({
                id: 0,
                journalEntryID: parseInt(this.$route.params.id),
                accountID: this.saveObj.bankAccountID,
                debit: 0,
                credit: totalDebit,
                chequeNo: this.saveObj.chequeTitle || "",
                description: this.saveObj.description || "Bank Account",
                campusID: this.$store.state.userData.cId,
              });
            } else if (totalCredit > 0) {
              // If credit amounts exist, bank account goes in debit
              this.myObj.push({
                id: 0,
                journalEntryID: parseInt(this.$route.params.id),
                accountID: this.saveObj.bankAccountID,
                debit: totalCredit,
                credit: 0,
                chequeNo: this.saveObj.chequeTitle || "",
                description: this.saveObj.description || "Bank Account",
                campusID: this.$store.state.userData.cId,
              });
            }
          }
        } else {
          // Remove bank account entry if no amounts
          if (bankEntry && bankEntry.id === 0 && this.myObj.length > 1) {
            const bankEntryIndex = this.myObj.findIndex(entry => entry.accountID === this.saveObj.bankAccountID && entry.id === 0);
            if (bankEntryIndex >= 0) {
              this.myObj.splice(bankEntryIndex, 1);
            }
          }
        }
      }
    },
    getAccountName(accountID) {
      if (!accountID || accountID === 0 || !this.accList || this.accList.length === 0) return '';
      const account = this.accList.find(acc => acc.id == accountID || acc.id === parseInt(accountID));
      return account ? account.title : '';
    },
    getAccountCode(accountID) {
      if (!accountID || accountID === 0 || !this.accList || this.accList.length === 0) return '';
      const account = this.accList.find(acc => acc.id == accountID || acc.id === parseInt(accountID));
      return account ? (account.code || '') : '';
    },
    getAccountById(accountID) {
      if (!accountID || !this.accList || this.accList.length === 0) return null;
      return (
        this.accList.find(
          (acc) => acc.id == accountID || acc.id === parseInt(accountID)
        ) || null
      );
    },
    isTableAccountSelectDisabled(item, ind) {
      if (this.isBankOrCreditVoucher) {
        return this.byGrn;
      }
      return this.byGrn || this.isBankAccountEntry(item, ind);
    },
    onTableAccountChange(item, ind) {
      if (!this.isBankOrCreditVoucher) return;

      const account = this.getAccountById(item.accountID);
      if (!account) return;

      if (!this.isBankOrCashAccount(item.accountID)) {
        return;
      }

      this.$set(item, "ledgerAmountLocked", false);
      this.saveObj.bankAccountID = item.accountID;
      this.$nextTick(() => {
        this.autoFillFlexibleLedgerRow(item, ind);
      });
    },
    isBankAccountEntry(item, ind) {
      if (this.allowFlexibleLedgerDrCr && this.isBankOrCreditVoucher) {
        return false;
      }
      // Check if this entry is the auto-filled bank account entry for bank/credit vouchers
      if (!this.isBankOrCreditVoucher || !this.saveObj.bankAccountID || this.saveObj.bankAccountID === 0) {
        return false;
      }
      return item.accountID === this.saveObj.bankAccountID;
    },

    /** Parse amount for debit/credit (supports decimals); strip commas; round to 2 dp for API. */
    normalizeLedgerAmount(value) {
      if (value === "" || value === null || value === undefined) return 0;
      const n = parseFloat(String(value).replace(/,/g, ""));
      if (!Number.isFinite(n) || n < 0) return 0;
      return Math.round(n * 100) / 100;
    },

    CheckValues() {
      let state = true;
      this.myObj.forEach((el) => {
        el.debit = this.normalizeLedgerAmount(el.debit);
        el.credit = this.normalizeLedgerAmount(el.credit);
        if (
          el.accountID == 0 ||
          !Number.isFinite(el.credit) ||
          !Number.isFinite(el.debit)
        ) {
          state = false;
        }
      });
      return state;
    },
    CheckVType() {
      // For transfer and journal vouchers, voucher type dropdown is not shown
      // So we don't need to check the ref, just validate the voucher type value
      if (!this.showVoucherTypeDropdown) {
        // For journal/transfer, voucher type should be "JV"
        if (this.saveObj.voucherType && this.saveObj.voucherType.trim() !== "") {
          return true;
        }
        return false;
      }
      
      var elem = this.$refs["vt"];
      if (!elem) {
        return true; // If ref doesn't exist, assume valid
      }
      if (this.saveObj.voucherType.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckVNum() {
      var re = /^[0-9]+$/;
      var elem = this.$refs["vNo"];
      let x = parseInt(this.saveObj.voucherNum);
      if (!re.test(this.saveObj.voucherNum) || isNaN(x) || x <= 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDep() {
      var elem = this.$refs["dep"];
      if (this.saveObj.departmentID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },

    async Add(val) {
      this.CheckVType();
      //this.CheckVNum();
      // this.CheckDep();
      if (
        this.CheckVType() == false ||
        // this.CheckDep() == false ||
        this.CheckValues() == false
      ) {
        this.check = 1;
        this.$bvToast.toast(this.$t("Please enter the details correctly"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        if (this.$route.params.id == 0 && this.saveObj.voucherType != "JV") {
          this.setAutoAccount();
          if (this.autoEntry != null) {
            this.myObj.push(this.autoEntry);
          }
        }
        // this.myObj.forEach((element) => {
        //   element.journalEntryID = 0;
        // });
        let entryForSave = { ...this.saveObj };
        if (parseInt(this.$route.params.id) === 0) {
          delete entryForSave.voucherNum;
        } else {
          entryForSave.voucherNum = parseInt(entryForSave.voucherNum);
        }
        let mybody = {
          entry: entryForSave,
          details: this.myObj,
        };
        const balDiff = Math.abs(this.totalDebit - this.totalCredit);
        if (balDiff > 0.005) {
          this.check = 1;
          this.$bvToast.toast("Debit and Credit must be equal!", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } else {
          // Set isReconciled based on voucher type
          // Bank vouchers (BPV, BRV) = false, others = true
          const vType = this.saveObj.voucherType;
          this.saveObj.isReconciled = (vType === "BPV" || vType === "BRV") ? false : true;
          
          // console.log("obj:", this.saveObj, this.myObj);
          // console.log(this.totalDebit, this.totalCredit);
          if (val === true) {
            this.saveObj.status = this.reviewObj?.valueBool
              ? "under review"
              : "pending";
          }
          this.request = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "JournalEntry/Save?db=" +
              this.$store.state.userData.db +
              "&userID=" +
              this.$store.state.userData.userID,
            body: mybody,
            message: "Journal saved successfully.",
            context: this,
            token: this.$store.state.userData.token,
            savingMarks: true,
            showError: true,
          });
          this.request = false;
          this.autoEntry = null;

          if (status) {
            this.saveLastVoucherPreferences({
              voucherType: this.saveObj.voucherType,
              accountID: this.saveObj.bankAccountID,
            });

            if (val == "print") {
              var url =
                `https://${this.reportDomain}.myskool.app/Account/PrintEntryVoucher?entryID=` +
                status.entry.id +
                "&dbb=" +
                this.$store.state.userData.db +
                "&cID=" +
                this.$store.state.userData.cId;

              window.open(url, "_blank");
            }
            if (this.grnObj) {
              this.grnObj.journalEntryID = 0;
              let pObj = [this.grnObj];
              this.updateGrn(pObj);
            } else if (this.supplierObj && this.selectedList.length > 0) {
              this.selectedList.forEach((el) => {
                el.journalEntryID = status.entry.id;
              });
              this.updateGrn(this.selectedList);
            }

            this.$router.go(-1);
          }
          this.check = 1;
        }
      }
    },
    async updateGrn(items) {
      var status = await this.post({
        url:
          this.$store.state.domain +
          "goodsReceivingNote/updateData?db=" +
          this.$store.state.userData.db,
        body: items,
        subjects: true,
        context: this,
        token: this.$store.state.userData.token,
      });
    },

    hideSideBar() {
      this.visibility = false;
    },
    hideSideBarVendor() {
      this.visibilityVendor = false;
    },
    goBack() {
      this.$router.go(-1);
    },

    async LoadAccounts() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Accounts/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      const raw = await this.get(obj);
      const list = this.normalizeAccountsResponse(raw);
      this.accList = this.filterAccountsByRole(list);
      // console.log("acc", this.accList);
      this.dataLoading = false;
      this.restoreLastVoucherAccount();
    },
    async loadDeps() {
      var obj = {
        url:
          this.$store.state.domain +
          "AccountsDepartment?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.depList = await this.get(obj);
      // console.log("dep", this.depList);
    },
    async loadVendors() {
      var obj = {
        url:
          this.$store.state.domain +
          "Vendors?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      var vData = await this.get(obj);

      // this.vendorList.push({
      //   id: 0,
      //   name: "None",
      //   mobile_number: "",
      //   campusID: this.$store.state.userData.cId,
      // });

      vData.forEach((element) => {
        this.vendorList.push({
          id: element.id,
          name: element.name,
          mobile_number: element.mobile_number,
          campusID: element.campusID,
        });
      });
      // console.log("dep", this.depList);
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style lang="scss" scoped>
.border-dashed {
  border: 1px solid var(--primary);
  border-style: dashed;
}
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.account-select {
  min-width: 100%;
  margin-top: 0 !important;
  
  ::v-deep .vs__dropdown-toggle {
    margin: 0 !important;
    margin-top: 0 !important;
  }
  
  ::v-deep .vs__selected-options {
    margin: 0 !important;
    margin-top: 0 !important;
    padding: 0 !important;
  }
}
.account-select ::v-deep .vs__dropdown-menu {
  min-width: 350px;
  max-width: 100%;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 9999 !important;
}

.account-select ::v-deep .vs__dropdown-option {
  padding: 0.75rem 1rem;
  transition: all 0.2s ease;
}
.account-select ::v-deep .vs__dropdown-menu::-webkit-scrollbar {
  width: 8px;
}
.account-select ::v-deep .vs__dropdown-menu::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.account-select ::v-deep .vs__dropdown-menu::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.account-select ::v-deep .vs__dropdown-menu::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.account-option {
  padding: 8px 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.account-option:hover {
  background-color: transparent;
}
.account-select ::v-deep .vs__dropdown-option--highlight {
  background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%) !important;
  color: #ffffff !important;

  .account-name {
    color: #ffffff !important;
  }

  .account-code {
    color: #ffffff !important;
    background: rgba(255, 255, 255, 0.2) !important;
  }
}
.account-select ::v-deep .vs__dropdown-option--selected {
  background-color: #f0edff !important;
  color: #5e5873 !important;
}
.account-select ::v-deep .vs__dropdown-option:hover {
  background-color: #faf9ff !important;
  color: #5e5873 !important;
}
.account-name {
  font-weight: 600;
  font-size: 14px;
  color: #2d1b69;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.account-code {
  font-size: 12px;
  color: #7c5dfa;
  font-weight: 600;
  margin-top: 4px;
  line-height: 1.3;
  background: #f0edff;
  padding: 3px 8px;
  border-radius: 4px;
  display: inline-block;
  width: fit-content;
}
.account-selected {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 8px;
  line-height: 1.3;
  max-width: 100%;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
}
.account-name-text {
  font-weight: 500;
  font-size: 13px;
  color: #5e5873;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  overflow-x: auto;
  overflow-y: hidden;
  line-height: 1.4;
  cursor: pointer;
  max-width: 100%;
  margin: 0;
  padding: 0;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}
.account-name-text::-webkit-scrollbar {
  height: 4px;
}
.account-name-text::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}
.account-name-text::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}
.account-name-text::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.account-code-text {
  font-size: 11px;
  color: #7c5dfa;
  font-weight: 700;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  line-height: 1.3;
  cursor: pointer;
  background: #f0edff;
  padding: 4px 10px;
  border-radius: 6px;
  display: inline-block;
  width: fit-content;
  flex-shrink: 0;
  margin: 0;
  border: 1px solid #e0d8ff;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}
.account-code-text::-webkit-scrollbar {
  height: 4px;
}
.account-code-text::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}
.account-code-text::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}
.account-code-text::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.account-select ::v-deep .vs__selected {
  white-space: normal;
  overflow-x: auto;
  overflow-y: hidden;
  height: auto;
  min-height: 38px;
  padding: 4px 8px;
  margin: 0 !important;
  display: flex;
  align-items: center;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}
.account-select ::v-deep .vs__selected::-webkit-scrollbar {
  height: 4px;
}
.account-select ::v-deep .vs__selected::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}
.account-select ::v-deep .vs__selected::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}
.account-select ::v-deep .vs__selected::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
@media (min-width: 768px) {
  .account-col {
    min-width: 280px;
    flex: 0 0 25%;
  }
  .debit-credit-col {
    min-width: 150px;
    flex: 0 0 16.666%;
  }
  .cheque-col {
    min-width: 120px;
    flex: 0 0 8.333%;
  }
  .note-col {
    min-width: 180px;
    flex: 0 0 16.666%;
  }
}

/* Voucher Header Section (inside combined card) */
.voucher-header-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
  flex-wrap: wrap;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #f0edff;

  @media (max-width: 768px) {
    flex-direction: column;
  }
}

.header-content {
  flex: 1;
  min-width: 300px;
}

.voucher-title {
  font-size: 1.75rem;
  font-weight: 800;
  color: #2d1b69;
  margin-bottom: 0.5rem;
  letter-spacing: -0.3px;
  line-height: 1.2;
}

.back-btn {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 2px solid #e0d8ff;
  background: #fff;
  color: #7c5dfa;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(124, 93, 250, 0.1);
  margin-right: 0.75rem;

  .back-arrow-icon {
    color: #7c5dfa;
    transition: color 0.3s ease;
  }

  &:hover {
    transform: translateX(-3px);
    background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%);
    border-color: #7c5dfa;
    box-shadow: 0 6px 20px rgba(124, 93, 250, 0.3);

    .back-arrow-icon {
      color: #ffffff;
    }
  }

  &:active {
    transform: translateX(-2px);
  }
}

.voucher-description {
  font-size: 0.95rem;
  color: #6b7280;
  font-weight: 500;
  margin-bottom: 0;
  line-height: 1.6;
}

.header-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
  }
}

.grn-search-input {
  min-width: 200px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(115, 103, 240, 0.1);

  ::v-deep .input-group-prepend {
    background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%);
    border: none;
    color: white;
    padding: 0.5rem 0.75rem;
  }

  ::v-deep .form-control {
    border: 1px solid #e0d8ff;
    border-left: none;
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;

    &:focus {
      border-color: #7c5dfa;
      box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.1);
    }
  }
}

.vendor-select {
  min-width: 200px;
}

/* Voucher Form Card */
.voucher-form-card {
  background: linear-gradient(180deg, #ffffff 0%, #faf9ff 100%);
  border: 1px solid #e0d8ff;
  border-radius: 20px;
  padding: 1.75rem;
  box-shadow: 0 10px 30px rgba(115, 103, 240, 0.12);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  animation: slideUpFade 0.5s ease-out both;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #7c5dfa 0%, #9d7aff 50%, #cbb9ff 100%);
  }

  &:hover {
    box-shadow: 0 15px 40px rgba(115, 103, 240, 0.2);
  }
}

/* Modern Form Group */
.form-group-modern {
  margin-bottom: 1.5rem;
}

.form-label-modern {
  font-size: 0.85rem;
  font-weight: 700;
  color: #2d1b69;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.5rem;
  display: block;
}

.form-label-with-icon {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.settings-icon {
  color: #7c5dfa;
  transition: all 0.3s ease;
  cursor: pointer;
  vertical-align: middle;
  flex-shrink: 0;

  &:hover {
    color: #6d4cdb;
    transform: rotate(90deg);
  }
}

/* Input Wrapper */
.input-wrapper-modern {
  position: relative;
  display: flex;
  align-items: center;
}

/* Date Input Wrapper */
.date-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.form-control-modern {
  width: 100%;
  height: 48px;
  padding: 0.75rem 1rem;
  padding-right: 2.5rem;
  font-size: 0.95rem;
  font-weight: 500;
  color: #2d1b69;
  background: #ffffff;
  border: 2px solid #e0d8ff;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(115, 103, 240, 0.08);
  line-height: 1.5;

  &::placeholder {
    color: #9ca3af;
    font-weight: 400;
  }

  &:focus {
    outline: none;
    border-color: #7c5dfa;
    box-shadow: 0 0 0 4px rgba(124, 93, 250, 0.1);
    background: #ffffff;
  }

  &:disabled {
    background-color: #f3f4f6;
    border-color: #d1d5db;
    cursor: not-allowed;
    opacity: 0.7;
  }
}

.date-input {
  height: 48px;
  padding: 0.75rem 1rem;
  padding-right: 2.5rem;
}

.input-icon {
  position: absolute;
  right: 1rem;
  color: #7c5dfa;
  pointer-events: none;
  z-index: 1;
}

.date-input-icon {
  position: absolute;
  right: 1rem;
  color: #7c5dfa;
  pointer-events: none;
  z-index: 1;
}

/* V-Select Simple Styling - Clean and Simple */
.v-select-simple {
  margin-top: 0 !important;
  
  ::v-deep .vs__dropdown-toggle {
    padding: 0;
    margin: 0 !important;
    border: 2px solid #e0d8ff;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0 2px 8px rgba(115, 103, 240, 0.08);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    min-height: 48px;
    height: 48px;
  }
  
  ::v-deep .vs__selected-options {
    margin: 0 !important;
    padding: 0 !important;
  }
  
  ::v-deep .vs__search-container {
    margin: 0 !important;
    padding: 0 !important;
  }

  ::v-deep .vs__search,
  ::v-deep .vs__search:focus {
    padding: 0.75rem 1rem;
    margin: 0;
    border: none;
    font-size: 0.95rem;
    font-weight: 500;
    color: #2d1b69;
    height: 100%;
    min-height: 48px;
  }

  ::v-deep .vs__selected {
    font-size: 0.95rem;
    font-weight: 500;
    color: #2d1b69;
    padding: 0.75rem 1rem;
    margin: 0 !important;
    line-height: 1.5;
    height: 100%;
    display: flex;
    align-items: center;
  }

  ::v-deep .vs__actions {
    padding: 0 0.5rem;
    height: 100%;
    display: flex;
    align-items: center;
    margin: 0 !important;
  }

  ::v-deep .vs__clear,
  ::v-deep .vs__open-indicator {
    fill: #7c5dfa;
  }

  ::v-deep .vs__dropdown-menu {
    border: 2px solid #e0d8ff;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(115, 103, 240, 0.15);
    margin-top: 0 !important;
    max-height: 300px;
    overflow-y: auto;
    z-index: 9999;
    top: 100% !important;
    transform: translateY(4px);
  }

  ::v-deep .vs__dropdown-option {
    padding: 0.75rem 1rem;
    font-size: 0.95rem;
    color: #2d1b69;
    transition: all 0.2s ease;
  }

  ::v-deep .vs__dropdown-option--highlight {
    background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%);
    color: #ffffff;
  }

  ::v-deep .vs__dropdown-option--selected {
    background: #f0edff;
    color: #7c5dfa;
    font-weight: 600;
  }

  &:focus-within {
    ::v-deep .vs__dropdown-toggle {
      border-color: #7c5dfa;
      box-shadow: 0 0 0 4px rgba(124, 93, 250, 0.1);
    }
  }
}

/* V-Select Modern Styling */
.v-select-modern {
  ::v-deep .vs__dropdown-toggle {
    padding: 0;
    border: 2px solid #e0d8ff;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0 2px 8px rgba(115, 103, 240, 0.08);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    min-height: 48px;
    height: 48px;
  }

  ::v-deep .vs__search,
  ::v-deep .vs__search:focus {
    padding: 0.75rem 1rem;
    margin: 0;
    border: none;
    font-size: 0.95rem;
    font-weight: 500;
    color: #2d1b69;
    height: 100%;
    min-height: 48px;
  }

  ::v-deep .vs__selected {
    font-size: 0.95rem;
    font-weight: 500;
    color: #2d1b69;
    padding: 0.75rem 1rem;
    margin: 0;
    line-height: 1.5;
    height: 100%;
    display: flex;
    align-items: center;
  }

  ::v-deep .vs__actions {
    padding: 0 0.5rem;
    height: 100%;
    display: flex;
    align-items: center;
  }

  ::v-deep .vs__clear,
  ::v-deep .vs__open-indicator {
    fill: #7c5dfa;
  }

  &:focus-within {
    ::v-deep .vs__dropdown-toggle {
      border-color: #7c5dfa;
      box-shadow: 0 0 0 4px rgba(124, 93, 250, 0.1);
    }
  }
}

/* Flatpickr Styling - Enhanced */
.date-input-wrapper {
  position: relative;
  
  ::v-deep .flatpickr-input {
    width: 100%;
    height: 48px;
    padding: 0.75rem 1rem;
    padding-right: 2.5rem;
    font-size: 0.95rem;
    font-weight: 500;
    color: #2d1b69;
    background: #ffffff;
    border: 2px solid #e0d8ff;
    border-radius: 12px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 8px rgba(115, 103, 240, 0.08);
    line-height: 1.5;
    cursor: pointer;

    &::placeholder {
      color: #9ca3af;
      font-weight: 400;
    }

    &:focus {
      outline: none;
      border-color: #7c5dfa;
      box-shadow: 0 0 0 4px rgba(124, 93, 250, 0.1);
      background: #ffffff;
    }

    &:hover {
      border-color: #b8a9ff;
      box-shadow: 0 4px 12px rgba(115, 103, 240, 0.12);
    }

    &:disabled {
      background-color: #f3f4f6;
      border-color: #d1d5db;
      cursor: not-allowed;
      opacity: 0.7;
    }
  }
}

/* Enhanced Date Input Wrapper */
.date-input-wrapper-enhanced {
  position: relative;
  
  ::v-deep .flatpickr-input {
    width: 100%;
    height: 48px;
    padding: 0.75rem 1rem;
    padding-right: 2.5rem;
    font-size: 0.95rem;
    font-weight: 500;
    color: #2d1b69;
    background: #ffffff;
    border: 2px solid #e0d8ff;
    border-radius: 12px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 8px rgba(115, 103, 240, 0.08);
    line-height: 1.5;
    cursor: pointer;

    &::placeholder {
      color: #9ca3af;
      font-weight: 400;
    }

    &:focus {
      outline: none;
      border-color: #7c5dfa;
      box-shadow: 0 0 0 4px rgba(124, 93, 250, 0.1);
      background: #ffffff;
    }

    &:hover {
      border-color: #b8a9ff;
      box-shadow: 0 4px 12px rgba(115, 103, 240, 0.12);
    }

    &:disabled {
      background-color: #f3f4f6;
      border-color: #d1d5db;
      cursor: not-allowed;
      opacity: 0.7;
    }
  }
}

.date-input-icon-enhanced {
  position: absolute;
  right: 0.875rem;
  top: 50%;
  transform: translateY(-50%);
  color: #7c5dfa;
  pointer-events: none;
  z-index: 1;
}

/* Attachments Section - Compact Header */
.attachments-header-compact {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.attachments-title-wrapper {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.attachments-title-compact {
  font-size: 1.5rem;
  font-weight: 800;
  color: #2d1b69;
  letter-spacing: -0.3px;
  margin: 0;
}

.attachment-add-btn-inline {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 0.875rem;
  border-radius: 10px;
  border: 2px solid #7c5dfa;
  background: linear-gradient(135deg, #ffffff 0%, #faf9ff 100%);
  color: #7c5dfa;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(124, 93, 250, 0.15);
  min-width: 44px;
  height: 44px;

  &:hover {
    background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%);
    color: #ffffff;
    border-color: #7c5dfa;
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 6px 20px rgba(124, 93, 250, 0.4);
  }

  &:active {
    transform: translateY(0) scale(0.98);
  }

  svg {
    width: 20px;
    height: 20px;
    transition: transform 0.3s ease;
  }

  &:hover svg {
    transform: rotate(90deg);
  }
}

.attachment-count-badge-inline {
  background: #7c5dfa;
  color: #ffffff;
  border-radius: 12px;
  padding: 3px 8px;
  font-size: 0.75rem;
  font-weight: 700;
  min-width: 22px;
  text-align: center;
  line-height: 1.4;
  box-shadow: 0 2px 4px rgba(124, 93, 250, 0.3);
  transition: all 0.3s ease;
}

.attachment-add-btn-inline:hover .attachment-count-badge-inline {
  background: #ffffff;
  color: #7c5dfa;
  box-shadow: 0 2px 6px rgba(255, 255, 255, 0.3);
}

.attachments-card {
  background: linear-gradient(180deg, #ffffff 0%, #faf9ff 100%);
  border: 1px solid #e0d8ff;
  border-radius: 20px;
  padding: 1.75rem;
  box-shadow: 0 10px 30px rgba(115, 103, 240, 0.12);
  margin-bottom: 2rem;
}

.attachments-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  align-items: flex-start;
  overflow: visible;
  padding: 8px;
}

.attachments-container-modal {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  align-items: flex-start;
  overflow: visible;
  padding: 8px;
  min-height: 200px;
}

.modal-footer-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 1rem;
  border-top: 1px solid #e0d8ff;
}

.attachment-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: slideUpFade 0.4s ease-out both;
  min-width: 100px;
  position: relative;
  overflow: visible;
  padding: 8px;
}

.attachment-circle-wrapper {
  position: relative;
  display: inline-block;
  width: 100px;
  height: 100px;
}

.attachment-circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 16px rgba(115, 103, 240, 0.2);
  overflow: hidden;
}

.attachment-add .attachment-circle {
  background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%);
  border: 3px dashed rgba(255, 255, 255, 0.5);
  
  .attachment-icon {
    color: #ffffff;
  }

  &:hover {
    transform: scale(1.1) rotate(90deg);
    box-shadow: 0 8px 24px rgba(124, 93, 250, 0.4);
  }

  &:active {
    transform: scale(0.95);
  }
}

.attachment-file {
  background: linear-gradient(135deg, #ffffff 0%, #f8f7ff 100%);
  border: 3px solid #e0d8ff;
  overflow: hidden;
  position: relative;
  
  .attachment-file-icon {
    color: #7c5dfa;
  }

  .attachment-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  .attachment-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }

  &:hover {
    transform: translateY(-5px) scale(1.05);
    border-color: #7c5dfa;
    box-shadow: 0 8px 24px rgba(124, 93, 250, 0.3);
  }
}

.attachment-delete {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ef4444 0%, #f87171 100%);
  display: flex !important;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.5);
  transition: all 0.3s ease;
  z-index: 100;
  border: 3px solid #ffffff;
  cursor: pointer;
  margin: 0;
  padding: 0;

  svg {
    width: 14px;
    height: 14px;
    stroke-width: 3;
    color: white !important;
    display: block;
  }

  &:hover {
    transform: scale(1.15);
    box-shadow: 0 6px 20px rgba(239, 68, 68, 0.6);
    background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
  }

  &:active {
    transform: scale(1.05);
  }
}

.attachment-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #6b7280;
  text-align: center;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Bottom Action Buttons Row - Separate from table buttons */
.action-buttons-row {
  display: flex;
  gap: 1rem;
  align-items: stretch;
  width: 100%;
  margin-top: 2rem;
  flex-wrap: wrap;

  @media (max-width: 992px) {
    flex-direction: column;
    gap: 1rem;
  }

  .action-btn {
    padding: 1rem 2.5rem;
    font-size: 1rem;
    font-weight: 700;
    border-radius: 8px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border: none;
    flex: 1;
    min-width: 200px;
    min-height: 50px;
    letter-spacing: 0.5px;
    color: white;
    white-space: nowrap;

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    }

    &:active:not(:disabled) {
      transform: translateY(0);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }

    svg,
    .feather-icon {
      margin-right: 0.75rem;
      flex-shrink: 0;
    }
  }

  .action-btn-save {
    background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%);
    border: none;
    color: white;

    &:hover:not(:disabled) {
      background: linear-gradient(135deg, #6d4cdb 0%, #8b6ff5 100%);
      color: white;
    }
  }

  .action-btn-print {
    background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%);
    border: none;
    color: white;

    &:hover:not(:disabled) {
      background: linear-gradient(135deg, #6d4cdb 0%, #8b6ff5 100%);
      color: white;
    }
  }

  .action-btn-approval {
    background: linear-gradient(135deg, #ffc107 0%, #ffb300 100%);
    color: #856404;
    border: none;

    &:hover:not(:disabled) {
      background: linear-gradient(135deg, #ffb300 0%, #ffa000 100%);
      color: #533f03;
    }
  }
}

/* Animation */
@keyframes slideUpFade {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Entries Table Styles */
.entries-table-card {
  background: linear-gradient(180deg, #ffffff 0%, #faf9ff 100%);
  border: 1px solid #e0d8ff;
  border-radius: 20px;
  padding: 0;
  box-shadow: 0 10px 30px rgba(115, 103, 240, 0.12);
  overflow: hidden;
}

.entries-table-wrapper {
  overflow-x: auto;
  padding: 1.5rem;
}

.entries-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(115, 103, 240, 0.08);
}

.entries-table thead {
  background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%);
}

.entries-table thead th {
  padding: 1rem 1.25rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: left;
  border: none;
  white-space: nowrap;
}

.entries-table thead th:first-child {
  border-top-left-radius: 12px;
}

.entries-table thead th:last-child {
  border-top-right-radius: 12px;
}

.entries-table tbody tr {
  transition: all 0.2s ease;
  border-bottom: 1px solid #f0edff;
}

.entries-table tbody tr:last-child {
  border-bottom: none;
}

.entries-table tbody tr:hover {
  background-color: #faf9ff;
}

.entries-table tbody td {
  padding: 1rem 1.25rem;
  vertical-align: middle;
  border: none;
}

.sno-col {
  width: 60px;
  text-align: center;
}

.sno-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: linear-gradient(135deg, #f0edff 0%, #e0d8ff 100%);
  color: #7c5dfa;
  font-weight: 700;
  font-size: 0.9rem;
  border: 2px solid #e0d8ff;
}

.account-col {
  min-width: 280px;
  width: auto;
}

.description-col {
  min-width: 200px;
  width: auto;
}

.debit-col,
.credit-col {
  width: 150px;
  min-width: 130px;
}

.action-col {
  width: 120px;
  text-align: center;
}

.amount-input {
  width: 100%;
  height: 42px;
  padding: 0.5rem 1rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: #2d1b69;
  background: #ffffff;
  border: 2px solid #e0d8ff;
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: right;

  &::placeholder {
    color: #9ca3af;
    font-weight: 400;
  }

  &:focus {
    outline: none;
    border-color: #7c5dfa;
    box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.1);
    background: #ffffff;
  }

  &:disabled {
    background-color: #f3f4f6;
    border-color: #d1d5db;
    cursor: not-allowed;
    opacity: 0.7;
  }
}

.debit-input:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.credit-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.description-input {
  width: 100%;
  height: 42px;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: #2d1b69;
  background: #ffffff;
  border: 2px solid #e0d8ff;
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &::placeholder {
    color: #9ca3af;
    font-weight: 400;
  }

  &:focus {
    outline: none;
    border-color: #7c5dfa;
    box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.1);
    background: #ffffff;
  }

  &:disabled {
    background-color: #f3f4f6;
    border-color: #d1d5db;
    cursor: not-allowed;
    opacity: 0.7;
  }
}

/* Account select in table - ensure proper height and positioning */
.entries-table .account-select {
  position: relative;
  z-index: 1;
  margin-top: 0 !important;

  ::v-deep .vs__dropdown-toggle {
    min-height: 42px;
    height: 42px;
    margin-top: 0 !important;
  }

  ::v-deep .vs__selected {
    min-height: 42px;
    height: 42px;
    padding: 0.5rem 1rem;
    margin: 0 !important;
    margin-top: 0 !important;
    display: flex;
    align-items: center;
  }

  ::v-deep .vs__search,
  ::v-deep .vs__search:focus {
    min-height: 42px;
    padding: 0.5rem 1rem;
  }

  ::v-deep .vs__dropdown-menu {
    z-index: 9999 !important;
    position: absolute !important;
  }
}

/* Ensure dropdown appears above table */
.entries-table-wrapper {
  position: relative;
  z-index: 0;
}

/* Table Action Buttons - Separate from bottom action buttons */
.table-action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.table-action-btn {
  width: 36px;
  height: 36px;
  padding: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 36px;
  min-height: 36px;

  &:hover:not(:disabled) {
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  &:active:not(:disabled) {
    transform: translateY(0) scale(0.95);
  }

  svg {
    width: 18px;
    height: 18px;
  }
}

.table-action-btn-add {
  background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%);
  border-color: #7c5dfa;
  color: #ffffff;

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #6d4cdb 0%, #8b6ff5 100%);
    border-color: #6d4cdb;
  }
}

.table-action-btn-remove {
  background: #ffffff;
  border-color: #ef4444;
  color: #ef4444;

  &:hover:not(:disabled) {
    background: #ef4444;
    color: #ffffff;
    border-color: #dc2626;
  }
}

/* Summary Section */
.entries-summary {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 1.5rem;
  background: linear-gradient(135deg, #faf9ff 0%, #f0edff 100%);
  border-top: 2px solid #e0d8ff;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.summary-right {
  display: flex;
  gap: 2rem;
  align-items: center;
  flex-wrap: wrap;
}

.summary-item {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
}

.summary-label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.summary-value {
  font-size: 1.1rem;
  font-weight: 800;
  color: #2d1b69;
  letter-spacing: -0.3px;
}

.debit-total {
  color: #10b981;
}

.credit-total {
  color: #3b82f6;
}

.difference-value {
  color: #2d1b69;
  transition: all 0.3s ease;
}

.difference-unbalanced {
  color: #ef4444 !important;
  animation: pulse-red 2s ease-in-out infinite;
}

@keyframes pulse-red {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

@media (max-width: 768px) {
  .entries-table-wrapper {
    padding: 1rem;
  }

  .entries-table thead th,
  .entries-table tbody td {
    padding: 0.75rem 0.5rem;
    font-size: 0.8rem;
  }

  .account-col {
    min-width: 180px;
  }

  .description-col {
    min-width: 150px;
  }

  .debit-col,
  .credit-col {
    min-width: 100px;
  }

  .entries-summary {
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
  }

  .summary-right {
    justify-content: space-around;
    width: 100%;
  }

  .summary-item {
    align-items: center;
    flex: 1;
  }
}
</style>

